import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import {
  Input,
  InputGroup,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  SelectPicker,
  Table,
  Whisper,
  Tooltip,
  IconButton,
  Modal,
  Message,
  useToaster,
  Form,
  Pagination,
  FlexboxGrid,
  Col,
  Loader,
  Checkbox
} from 'rsuite';
import MenuIcon from '@rsuite/icons/Menu';
import TagAuthorizeIcon from '@rsuite/icons/TagAuthorize';
import SearchIcon from '@rsuite/icons/Search';
import VisibleIcon from '@rsuite/icons/Visible';
import MoreIcon from '@rsuite/icons/More';
import SortDownIcon from '@rsuite/icons/SortDown';
import TrashIcon from '@rsuite/icons/Trash';
import globalIP from '@/GlobelIP';
import { Link, useNavigate } from 'react-router-dom';
import EmailIcon from '@rsuite/icons/Email';
import LoadingBar from 'react-top-loading-bar';
import imger from '../../assets/images/items/whatsapp.svg';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { jsPDF } from 'jspdf';
import ugr from '@/UGRoute';
import excelimg from './template/excel.png';
import ppfimg from './template/pdfFinal.png';
import { FaPrint } from 'react-icons/fa';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import EditIcon from '@rsuite/icons/Edit';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import ShowDimensionModal from '@/components/ShowDimensionModal';
import ViewModal from '@/components/ViewModal';
import Email from '@/components/Email';
import WhatsApp from '@/components/WhatsApp';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const { Column, HeaderCell, Cell } = Table;
const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

const ManageOrdQ = () => {
  const ip = globalIP;
  const [selectedOption, setSelectedOption] = useState('Option 1');
  const handleOptionChange = value => {
    setSearchQuery('');
    setSelectedOption(value);
  };

  const [compdata, setCompData] = useState<any>([]);
  // Add this to your state variables
  const [downloadedFile, setDownloadedFile] = useState<{
    filename: string;
    blob: Blob | null;
    base64: string | null;
  }>({
    filename: '',
    blob: null,
    base64: null
  });
  const [waterMarkAccess, setWaterMarkAccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [waterMark, setWaterMark] = useState(false);
  const [cataloguedata, setCatalogueData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedBuyerName, setSelectedBuyerName] = useState('');
  const [selectedBuyerCompName, setSelectedBuyerCompName] = useState('');
  const [productData, setProductData] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [metaedit, setMetaEdit] = useState<MetaData>();
  const [metaview, setMetaView] = useState<MetaData>();
  const [progress, setProgress] = useState(0);
  const [page, setPage] = useState(1);
  const [pageview, setPageView] = useState(1);
  const [pageedit, setPageEdit] = useState(1);
  const [reload, setReload] = useState(false);
  const [page1, setPage1] = useState(1);
  const [selectedOption1, setSelectedOption1] = useState('Active');
  useEffect(() => {
    setWaterMarkAccess(compdata?.attributes?.Wqutation);
  }, [compdata]);
  const handleChangeLimitforviw = () => {
    setPageView(1);
  };
  const handleChangeLimitEdit = () => {
    setPageEdit(1);
  };

  const handleOptionChange1 = value => {
    setSelectedOption1(value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setSearchQuery('');
    fetchData();
  }, [
    page,
    selectedOption1,
    pageedit,
    reload,
    selectedOption,
    selectedBuyerName,
    selectedBuyerCompName
  ]);

  // let setSearchQryBtn = false;
  const [searchQuery, setSearchQuery] = useState('');

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setPage(1);
    setPage1(1);
    setCatalogueData([]);
    fetchData();
    fetchData1();
  }, [debouncedSearchQuery]);

  const fetchData = async () => {
    setProgress(30);
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][QuotationName][$containsi]=${searchQryy}&filters[$or][1][Q_BuyerCompany][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
      setPage(1);
    }
    const buyerNameFilter =
      selectedBuyerName?.length > 0
        ? `&filters[Q_BuyerName][$eq]=${encodeURIComponent(selectedBuyerName)}`
        : '';
    const buyerCompanyNameFilter =
      selectedBuyerCompName?.length > 0
        ? `&filters[Q_BuyerCompany][$eq]=${encodeURIComponent(selectedBuyerCompName)}`
        : '';

    // let buyerNameFilter = '';
    // if (selectedBuyerName.length > 0) {
    //   buyerNameFilter = `&filters[Q_BuyerCompany][$eq]=${selectedBuyerName}`;
    // }

    // let searchOption = '';
    // if (selectedOption.length > 0) {
    //   searchOption = `&filters[BuyerCompany][$eq]=${selectedOption}`;
    // }

    let url = `${ip}/api/quotations?populate=*&pagination[page]=${page}&sort[0]=id:desc${buyerNameFilter}${buyerCompanyNameFilter}${searchQryFilter}`;
    if (selectedOption1 !== 'All') {
      url += `&filters[Q_Status][$eq]=${selectedOption1}&sort[0]=id:desc`;
    }

    // let url = `${ip}/api/quotations?populate=*&pagination[page]=${page}&sort[0]=id:desc`;
    // if (selectedOption1 !== 'All') {
    //   url += `&filters[Q_Status][$eq]=${selectedOption1}&sort[0]=id:desc`;
    // }
    const response = await fetch(url);
    setProgress(60);
    const json = await response.json();
    setMeta123(json.meta);
    setIsLoading(false);
    setProgress(100);

    const productResponse = await fetch(
      `${ip}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${pageedit}`
    );
    const productJson = await productResponse.json();
    setProductData(productJson.data);
    setMetaEdit(productJson.meta);
    const updatedCatalogueData = json.data.map(item => ({
      ...item,
      itemCount: item.attributes.QuotationProduct.length
    }));
    setCatalogueData(updatedCatalogueData);
    setIsLoading1(false);
  };

  const [cataloguedata1, setCatalogueData1] = useState([]);
  const [isLoading1, setIsLoading1] = useState(false);
  const [productData1, setProductData1] = useState([]);
  const [meta1231, setMeta1231] = useState<MetaData>();
  useEffect(() => {
    fetchData1();
    window.addEventListener('scroll', handleScroll1);
    return () => {
      window.removeEventListener('scroll', handleScroll1);
    };
  }, []);

  useEffect(() => {
    setSearchQuery('');
    fetchData1();
  }, [page1, selectedBuyerName, selectedBuyerCompName, selectedOption1]);

  const fetchData1 = async () => {
    if (isLoading1) {
      return;
    }

    setIsLoading1(true);
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][catalogueName][$containsi]=${searchQryy}&filters[$or][1][BuyerCompany][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
      setPage(1);
    }

    const buyerNameFilter =
      selectedBuyerName?.length > 0
        ? `&filters[BuyerName][$eq]=${encodeURIComponent(selectedBuyerName)}`
        : '';
    const buyerCompanyNameFilter =
      selectedBuyerCompName?.length > 0
        ? `&filters[BuyerCompany][$eq]=${encodeURIComponent(selectedBuyerCompName)}`
        : '';

    let searchOption1 = '';
    if (selectedOption1.length > 0) {
      if (searchOption1 !== 'All') {
        searchOption1 = `&filters[Status][$eq]=${selectedOption1}`;
      }
    }

    const response = await fetch(
      `${ip}/api/catalogues?populate=*&pagination[page]=${page1}&sort[0]=id:desc${searchQryFilter}${buyerNameFilter}${buyerCompanyNameFilter}${searchOption1}`
    );
    const json = await response.json();
    // const allData = [];
    // for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
    //   const pageResponse = await fetch(`${ip}/api/catalogues?populate=*&pagination[page]=${page}`);
    //   const pageJson = await pageResponse.json();
    //   allData.push(...pageJson.data);
    // }
    setMeta1231(json.meta);
    // setCatalogueData1(allData);
    setIsLoading1(false);

    const productResponse = await fetch(`${ip}/api/products?populate=*`);
    const productJson = await productResponse.json();
    setProductData1(productJson.data);

    const updatedCatalogueData = json.data.map(item => ({
      ...item,
      itemCount: item.attributes.CatalogueProduct.length
    }));
    setCatalogueData1(updatedCatalogueData);
  };
  const handleScroll1 = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollHeight - (scrollTop + clientHeight) < 100) {
      // You can adjust the threshold
      // Load more data
      // In this case, we don't need to fetch more data as we have already fetched all pages upfront.
      // We can simply show more items from the `data123` array.
    }
  };
  const [buyeerdata, setBuyeerdata] = useState([]);
  const [buyeerCompNamedata, setBuyeerCompNamedata] = useState([]);
  const [allBuyerData, setAllBuyerData] = useState([]);

  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${globalIP}/api/buyer-details`);
      const json = await response.json();
      const data = json.data ?? [];

      setAllBuyerData(data);

      const uniqueCompanyNames = Array.from(
        new Set(data.map(item => item.attributes.companynm?.trim() || ''))
      );

      const processedBuyerCompanyNameData = uniqueCompanyNames.map(companyName => ({
        label: companyName,
        value: companyName
      }));

      setBuyeerCompNamedata(processedBuyerCompanyNameData);

      const initialFiltered = selectedBuyerCompName
        ? data.filter(
            item =>
              item.attributes.companynm?.trim().toLowerCase() ===
              selectedBuyerCompName.trim().toLowerCase()
          )
        : data;

      const processedBuyerNameData = initialFiltered.map(item => ({
        label: item?.attributes?.buyernm || '',
        value: item?.attributes?.buyernm || '',
        company: item?.attributes?.companynm?.trim() || ''
      }));

      setBuyeerdata(processedBuyerNameData);
    } catch (error) {
      console.error('Error fetching buyer data:', error);
    }
  };

  useEffect(() => {
    if (!allBuyerData || allBuyerData.length === 0) return;

    const filtered = selectedBuyerCompName
      ? allBuyerData.filter(
          item =>
            item.attributes.companynm?.trim().toLowerCase() ===
            selectedBuyerCompName.trim().toLowerCase()
        )
      : allBuyerData;

    const processed = filtered.map(item => ({
      label: item?.attributes?.buyernm || '',
      value: item?.attributes?.buyernm || '',
      company: item?.attributes?.companynm?.trim() || ''
    }));

    setBuyeerdata(processed);
  }, [selectedBuyerCompName, allBuyerData]);

  const [foundProductCount, setFoundProductCount] = useState(0);

  const handleSearch = value => {
    setSearchQuery(value);
    const matchingProductsCount = cataloguedata.filter(item => {
      const productName = item.attributes.QuotationName.toLowerCase();
      const aliasCode = item.attributes.Q_BuyerCompany.toLowerCase();
      const ContNo = item.attributes.QuotationCode.toLowerCase();

      return (
        productName.includes(value.toLowerCase()) ||
        aliasCode.includes(value.toLowerCase()) ||
        ContNo.includes(value.toLowerCase())
        // ... other conditions ...
      );
    }).length;

    setFoundProductCount(matchingProductsCount);
  };
  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fetchProducts1, setFetchedProducts] = useState([]);
  const [productalldata, setProductAlldata] = useState([]);
  const [cataname, setCataname] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const handleMoreIconClick = async rowData => {
    const catalogueProducts = rowData.attributes.QuotationProduct.map(
      product => product.QuotationProductcode
    );
    // Fetch main products based on selectedCatalogProduct
    setCataname(rowData.attributes.QuotationName);
    const matchingIds = catalogueProducts.map(catalogProduct => catalogProduct);
    setProductAlldata(matchingIds);
    // await fetchProducts(matchingIds);
    setIsModalOpen(true);
  };
  useEffect(() => {
    if (productalldata.length) {
      fetchProducts(productalldata);
    }
  }, [productalldata, pageview]);
  const fetchProducts = async matchingIds => {
    try {
      // Create an array of query parameters for each matching ID
      const productIdsQueryParam = matchingIds.map(id => `filters[id][$in][]=${id}`).join('&');
      // Construct the API URL by appending the query parameters
      const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*&sort[0]=id:desc&pagination[page]=${pageview}`;
      const apiUrl1 = `${ip}/api/variant-products?${productIdsQueryParam}&populate=*&sort[0]=id:desc&pagination[page]=${pageview}`;
      // Fetch data from the API
      const response = await fetch(apiUrl);
      const response1 = await fetch(apiUrl1);
      const json = await response.json();
      const json1 = await response1.json();
      const catadata = [...json.data, ...json1.data];
      setMetaView(json.meta);
      // Set the fetched products
      setFetchedProducts(catadata);
      setCurrentPage(pageview);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const [data123, setData123] = useState([]);

  useEffect(() => {
    fetchDatad();
  }, []);
  const fetchDatad = async () => {
    const response = await fetch(`${ip}/api/products?populate=*&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ip}/api/products?populate=*&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setData123(allData);
  };
  function getStatusButtonClass(status) {
    if (status === 'Inactive') {
      return 'inactive-button';
    } else if (status === 'Active') {
      return 'active-button';
    } else if (status === 'Draft') {
      return 'draft-button';
    }
    // You can add more conditions for other status values if needed.
  }

  const history = useNavigate();
  const handleCreateQuotation = catalogueCode => {
    const catalogue = cataloguedata1.find(item => item.attributes.CatalogueCode === catalogueCode);
    if (catalogue) {
      const catalogueProducts = catalogue.attributes.CatalogueProduct.map(
        product => product.CatalogProduct
      );
      if (catalogueProducts) {
        history(`/${ugr}/editDetailsQ?selectedItems=${catalogueProducts.join(',')}`);
      }
    }
  };
  const [filterApplied, setFilterApplied] = useState(false);
  const toaster = useToaster();
  const [rowToDelete, setRowToDelete] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const handleConfirmDelete = () => {
    handleDeleteRow(rowToDelete);
    setShowModal(false);
  };
  const openDeleteModal = rowId => {
    setRowToDelete(rowId);
    setShowModal(true);
  };
  const closeDeleteModal = () => {
    setShowModal(false);
  };
  const handleDeleteRow = async rowId => {
    try {
      const response = await fetch(`${ip}/api/quotations/${rowId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        // Row deletion was successful, update your local data or refresh the table
        const updatedData = cataloguedata.filter(row => row.id !== rowId);
        setCatalogueData(updatedData);
        console.log('Row deleted successfully.');
        toaster.push(
          <Message showIcon type="success">
            Delete Quotation Successfully
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        console.log('Failed to delete row.');
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };
  const [isStatusPickerVisible, setStatusPickerVisible] = useState({});
  const toggleStatusPicker = rowId => {
    setStatusPickerVisible(prevState => ({
      ...prevState,
      [rowId]: !prevState[rowId]
    }));
  };
  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' }
  ];

  const handleStatusChange = async (catalogId, newStatus) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...cataloguedata,
        Q_Status: newStatus
      })
    );

    fetch(`${ip}/api/quotations/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData();
      })
      .catch(error => {
        console.error(error);
      });
    setStatusPickerVisible(false);
  };
  /// Email system start
  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [attachment, setAttachment] = useState<{
    filename: string | null;
    contentType: string | null;
    content: string | null;
    source: 'api' | 'manual' | null; // नया field
  }>({
    filename: null,
    contentType: null,
    content: null,
    source: null
  });

  const handleAttachmentChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = event => {
        const base64Content = event.target.result.split(',')[1];
        // Manual upload होने पर पहले वाली file replace करें
        setAttachment({
          filename: file.name,
          contentType: file.type,
          content: base64Content,
          source: 'manual' // Mark as manual upload
        });
      };
      reader.readAsDataURL(file);

      // Reset file input ताकि same file फिर से select की जा सके
      e.target.value = '';
    }
  };
  const sendemail = async () => {
    const endpoint = `${ip}/api/send-mail`;

    const data: any = {
      toEmail: to,
      subject: subject,
      message: message
    };

    if (attachment.filename && attachment.content) {
      data.attachments = [
        {
          filename: attachment.filename,
          contentType: attachment.contentType || '',
          base64: attachment.content
        }
      ];
    }

    try {
      setLoading(true);
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        console.log('Email sent successfully!');

        // Success message
        toaster.push(
          <Message showIcon type="success">
            Email sent successfully!
          </Message>,
          { placement: 'topEnd' }
        );

        // Reset everything after successful email
        resetEmailForm();

        handleClose();
      } else {
        console.error('Failed to send email');
        toaster.push(
          <Message showIcon type="error">
            Failed to send email. Please try again.
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error:', error);
      toaster.push(
        <Message showIcon type="error">
          Error sending email. Please check your connection.
        </Message>,
        { placement: 'topEnd' }
      );
    } finally {
      setLoading(false);
    }
  };

  // New function to reset email form
  const resetEmailForm = () => {
    // Reset all email-related states
    setTo('');
    setSubject('');
    setMessage('');
    setAttachment({
      filename: null,
      contentType: null,
      content: null,
      source: null
    });

    // Also reset downloaded file if needed
    setDownloadedFile({
      filename: '',
      blob: null,
      base64: null
    });
  };
  /// Email system end

  // Buyer Activity Modal function Start
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  // const handleOpen = (value, buyerEmail, BuyerCompany) => {
  //   setSize(value);
  //   setOpen(true);
  //   setTo(buyerEmail);
  //   setSubject('Regarding for Query');
  //   setMessage('Hello ' + BuyerCompany);
  // };

  const handleRemoveAttachment = () => {
    setAttachment({
      filename: null,
      contentType: null,
      content: null,
      source: null
    });
  };

  const handleOpen = async (value, buyerEmail, BuyerCompany, rowData = null) => {
    setSize(value);
    setOpen(true);

    const quotationProductCodes =
      rowData?.attributes?.QuotationProduct?.map(p => p.QuotationProductcode) || [];

    const emailToSet = buyerEmail || 'No email available';
    setTo(emailToSet);
    setSubject(`Quotation: ${rowData?.attributes?.QuotationName || 'Document'}`);
    setMessage(
      `Hello ${BuyerCompany},\n\nPlease find the attached quotation document.\n\nBest regards,\n${
        compdata?.attributes?.cmpnm || 'Your Company'
      }`
    );
    setCatalogueByid(quotationProductCodes);

    // Fetch fresh products in real-time
    const fetchProductsEX = async () => {
      try {
        if (!quotationProductCodes.length) return [];

        const productIdsQueryParam = quotationProductCodes
          .map(id => `filters[id][$in][]=${id}`)
          .join('&');

        let allProducts = [];
        let currentPage = 1;
        let hasMorePages = true;

        while (hasMorePages) {
          const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*&sort[0]=id:desc&pagination[page]=${currentPage}`;
          const apiUrl1 = `${ip}/api/variant-products?${productIdsQueryParam}&populate=*&sort[0]=id:desc&pagination[page]=${currentPage}`;

          const [response, response1] = await Promise.all([fetch(apiUrl), fetch(apiUrl1)]);

          const json = await response.json();
          const json1 = await response1.json();

          const pageData = [...json.data, ...json1.data];
          allProducts = [...allProducts, ...pageData];

          hasMorePages = currentPage < json.meta.pagination.pageCount;
          currentPage++;
        }

        return allProducts;
      } catch (error) {
        console.error('Error fetching products:', error);
        return [];
      }
    };

    const realTimeProducts = await fetchProductsEX();
    setCataPro(realTimeProducts); // Update state if needed

    // Generate CSV from fresh products
    const csvData = realTimeProducts.map(item => {
      const { id, attributes } = item;
      const {
        MaterialCollection,
        MultipleImage,
        CoverImage,
        FortyHQ,
        FortyFT,
        TwentyFT,
        Total_CBM,
        publishedAt,
        updatedAt,
        createdAt,
        BuyerName,
        cbm,
        ProductTypeCode,
        MadeBy,
        ProductDesigner,
        MOQ,
        SearchKeyword,
        HSNCode,
        ColorCode,
        FinishCode,
        ProductCode,
        CategoryCode,
        Total_CFT,
        ...restAttributes
      } = attributes;

      const imageUrl = `${ip}${CoverImage?.data?.attributes?.url || ''}`;

      return {
        id,
        Image: imageUrl,
        ...restAttributes
      };
    });

    const file = await downloadExcelData(csvData);

    if (file.base64 && file.filename) {
      setAttachment({
        filename: file.filename,
        contentType: file.filename.endsWith('.pdf')
          ? 'application/pdf'
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        content: file.base64,
        source: 'api'
      });
    } else {
      setAttachment({
        filename: null,
        contentType: null,
        content: null,
        source: null
      });
    }
  };

  const handleClose = () => setOpen(false);
  // Buyer Activity Modal function End

  const [cata, setCata] = useState([]);
  const [qutname, setQutName] = useState('');

  const [val, setVal] = useState('');
  const [cataloguebyid, setCatalogueByid] = useState([]);

  const [bname, setBname] = useState('');
  const [qdate, setQdate] = useState(null);
  const [baddress, setBaddress] = useState('');
  const [bemail, setBemail] = useState('');
  const [qdata, setQata] = useState([]);
  const fetchDatabyid = async rowid => {
    console.log('row id : ', rowid);
    const response = await fetch(`${ip}/api/quotations?populate=*&filters[id][$eq]=${rowid}`);
    const json = await response.json();
    console.log('Customer data from Qutation : ', json);
    const catalogProducts = json.data.flatMap(catalogue =>
      catalogue.attributes.QuotationProduct.map(product => product.QuotationProductcode)
    );
    setQata(json.data.flatMap(catalogue => catalogue.attributes.QuotationProduct));
    const customerAddress = await fetch(`${ip}/api/buyer-details`);
    const customerAddress_Response = await customerAddress.json();
    // console.log(customerAddress_Response)
    // console.log("data" ,customerAddress_Response.data)
    const qBuyerName = json.data[0]?.attributes?.Q_BuyerName;

    const filteredCustomers = customerAddress_Response.data.filter(
      customer => customer.id === parseInt(qBuyerName, 10)
    );
    // console.log("filter customer by id :", filteredCustomers)
    // console.log("address :", filteredCustomers[0].attributes.address)

    // setBaddress(filteredCustomers[0].attributes.address)
    const createdDate = new Date(json.data[0]?.attributes.createdAt);
    const formattedDate = `${createdDate.getDate().toString().padStart(2, '0')}/${(
      createdDate.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}/${createdDate.getFullYear()}`;

    setQdate(formattedDate);
    setBname(json.data[0]?.attributes.Q_BuyerName);
    setBemail(json.data[0]?.attributes.Q_BuyerEmail);
    setCatalogueByid(catalogProducts);
    const qutname = json.data.map(item => item.attributes.QuotationName);
    setQutName(qutname);
    setVal('1');
  };

  useEffect(() => {
    if (cataloguebyid) {
      fetchProductsEX();
    }
  }, [cataloguebyid, open]);
  // const fetchProductsEX = async () => {
  //   try {
  //     // Create an array of query parameters for each matching ID
  //     const productIdsQueryParam = cataloguebyid.map(id => `filters[id][$in][]=${id}`).join('&');
  //     // Construct the API URL by appending the query parameters
  //     const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*`;
  //     const apiUrl1 = `${ip}/api/variant-products?${productIdsQueryParam}&populate=*`;
  //     const response = await fetch(apiUrl);
  //     const response1 = await fetch(apiUrl1);
  //     const json = await response.json();
  //     const json1 = await response1.json();
  //     const catadata = [...json.data, ...json1.data];
  //     // Set the fetched products
  //     if (val === '1') {
  //       setCata(catadata);
  //       formatOpen();
  //     }
  //     // downloadExcelData(csvData);
  //   } catch (error) {
  //     console.error('Error fetching products:', error);
  //   }
  // };
  const [cataPro, setCataPro] = useState([]);
  const fetchProductsEX = async () => {
    try {
      if (!cataloguebyid.length) {
        return;
      }

      // Create an array of query parameters for each matching ID
      const productIdsQueryParam = cataloguebyid.map(id => `filters[id][$in][]=${id}`).join('&');

      // Fetch all products across all pages
      let allProducts = [];
      let currentPage = 1;
      let hasMorePages = true;

      while (hasMorePages) {
        const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*&sort[0]=id:desc&pagination[page]=${currentPage}`;
        const apiUrl1 = `${ip}/api/variant-products?${productIdsQueryParam}&populate=*&sort[0]=id:desc&pagination[page]=${currentPage}`;

        const [response, response1] = await Promise.all([fetch(apiUrl), fetch(apiUrl1)]);

        const json = await response.json();
        const json1 = await response1.json();

        const pageData = [...json.data, ...json1.data];
        allProducts = [...allProducts, ...pageData];

        // Check if there are more pages
        hasMorePages = currentPage < json.meta.pagination.pageCount;
        currentPage++;
      }

      setCataPro(allProducts);
      // Set the fetched products (all of them)
      if (val === '1') {
        setCata(allProducts);
        // formatOpen();
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };
  const csvData = cata.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      MultipleImage,
      CoverImage,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerName,
      cbm,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;

    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });

  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchDatacd();
  }, []);
  const fetchDatacd = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };

  const downloadExcelData = async (data, unit = 'cm', currency = 'USD') => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Quotation', {
      properties: { tabColor: { argb: 'FFC00000' } }
    });

    const compname = compdata?.attributes?.cmpnm;
    const country = compdata?.attributes?.country;
    const address = compdata?.attributes?.address;
    // const email = compdata?.attributes?.email_id;
    const email =
      compdata?.attributes?.ContactDetail?.map(detail => detail.email).join(', ') || 'No Email';
    const contactno = compdata?.attributes?.contactno;
    const contactperson = compdata?.attributes?.ContactDetail.map(detail => detail.Name).join(', ');
    const personmobile = compdata?.attributes?.ContactDetail.map(detail => detail.mobileno).join(
      ', '
    );

    // Header Title
    worksheet.mergeCells('A1:W2');
    const headerCell = worksheet.getCell('A1');
    headerCell.value = 'Quotation';
    headerCell.alignment = { vertical: 'middle', horizontal: 'center' };
    headerCell.font = { size: 16, bold: true };
    headerCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCE5FF' } };

    // Vendor Details
    worksheet.mergeCells('A3:I7');
    const vendorCell = worksheet.getCell('A3');
    vendorCell.value = `Vendor Name: ${compname}\nCountry: ${country}\nAddress: ${address}\nContact Person: ${contactperson}\nMobile No.: ${personmobile}\nEmail: ${email}`;
    vendorCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
    vendorCell.font = { size: 10 };
    vendorCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Buyer Details
    worksheet.mergeCells('J3:O7');
    const buyerCell = worksheet.getCell('J3');
    buyerCell.value = `Buyer Name: ${bname}\nTel: ${'N/A'}`;
    buyerCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
    buyerCell.font = { size: 10 };
    buyerCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Quotation Details
    worksheet.mergeCells('P3:W7');
    const quotationCell = worksheet.getCell('P3');
    quotationCell.value = `Quotation Date: ${qdate}\nPayment Terms: 30% Advance 70% Against OBL\nProduction Lead Time: 90 Days\nPrice Terms: FOB\nPort of Loading: Mundra / Nhava Sheva`;
    quotationCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
    quotationCell.font = { size: 10 };
    quotationCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // ===== HEADER ROWS =====
    worksheet.mergeCells('E8:G8'); // Dimensions
    worksheet.getCell('E8').value = 'Dimensions';
    worksheet.getCell('E8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('E8').font = { bold: true };

    worksheet.mergeCells('H8:H9'); // Unit (swapped)
    worksheet.getCell('H8').value = 'Unit';
    worksheet.getCell('H8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('H8').font = { bold: true };

    worksheet.mergeCells('I8:I9'); // Color/Finish (swapped)
    worksheet.getCell('I8').value = 'Color/Finish';
    worksheet.getCell('I8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('I8').font = { bold: true };

    worksheet.mergeCells('L8:M8'); // Carton Qty
    worksheet.getCell('L8').value = 'Carton Qty';
    worksheet.getCell('L8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('L8').font = { bold: true };

    worksheet.mergeCells('Q8:S8'); // Carton Size
    worksheet.getCell('Q8').value = 'Carton Size';
    worksheet.getCell('Q8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('Q8').font = { bold: true };

    worksheet.mergeCells('A8:A9');
    worksheet.mergeCells('B8:B9');
    worksheet.mergeCells('C8:C9');
    worksheet.mergeCells('D8:D9');
    worksheet.mergeCells('J8:J9');
    worksheet.mergeCells('K8:K9');
    worksheet.mergeCells('N8:N9');
    worksheet.mergeCells('O8:O9');
    worksheet.mergeCells('P8:P9');
    worksheet.mergeCells('T8:T9');
    worksheet.mergeCells('U8:U9');
    worksheet.mergeCells('V8:V9');
    worksheet.mergeCells('W8:W9');

    // Header values
    worksheet.getCell('A8').value = 'Sr No.';
    worksheet.getCell('B8').value = 'Supp.\nItem No.';
    worksheet.getCell('C8').value = 'Image';
    worksheet.getCell('D8').value = 'Description';
    worksheet.getCell('J8').value = 'Materials Used';
    worksheet.getCell('K8').value = 'Net Weight (Kg)';
    worksheet.getCell('N8').value = `F.O.B Unit Price (${selectedCurrency || 'INR'})`;
    worksheet.getCell('O8').value = 'Currency';
    worksheet.getCell('P8').value = 'MOQ';
    worksheet.getCell('T8').value = 'Unit';
    worksheet.getCell('U8').value = 'Unit(Set/Pc)';
    worksheet.getCell('V8').value = 'CBM/CNT';
    worksheet.getCell('W8').value = 'Remarks';

    // Subheaders
    worksheet.getCell('E9').value = 'L';
    worksheet.getCell('F9').value = 'W';
    worksheet.getCell('G9').value = 'H';
    worksheet.getCell('L9').value = 'Inner';
    worksheet.getCell('M9').value = 'Master';
    worksheet.getCell('Q9').value = 'L';
    worksheet.getCell('R9').value = 'W';
    worksheet.getCell('S9').value = 'H';

    // Style headers
    const headerRow1 = worksheet.getRow(8);
    const headerRow2 = worksheet.getRow(9);
    [headerRow1, headerRow2].forEach(row => {
      row.eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF000000' } };
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
        };
      });
    });

    // Column widths (swapped H and I)
    worksheet.columns = [
      { width: 6 }, // A - Sr No.
      { width: 15 }, // B - Supp. Item No.
      { width: 12 }, // C - Image
      { width: 50 }, // D - Description
      { width: 8 }, // E - L
      { width: 8 }, // F - W
      { width: 8 }, // G - H
      { width: 8 }, // H - Unit (swapped)
      { width: 14 }, // I - Color/Finish (swapped)
      { width: 18 }, // J - Materials
      { width: 15 }, // K - Net Wt
      { width: 8 }, // L - Inner
      { width: 8 }, // M - Master
      { width: 25 }, // N - FOB
      { width: 10 }, // O - Currency
      { width: 10 }, // P - MOQ
      { width: 8 }, // Q - Carton L
      { width: 8 }, // R - Carton W
      { width: 8 }, // S - Carton H
      { width: 10 }, // T - Carton Unit
      { width: 12 }, // U - Unit(Set/Pc)
      { width: 10 }, // V - CBM/CNT
      { width: 15 } // W - Remarks
    ];

    const safeNumber = val => (isNaN(parseFloat(val)) ? 0 : parseFloat(val));

    let rowIndex = 10;
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      const { Image } = item;
      const originalUnit = item.SizeUnit?.toLowerCase() === 'inch' ? 'inch' : 'cm';
      const quotation = qdata.find(q => q.QuotationProductcode == item.id);
      // const price = safeNumber(quotation ? quotation.Price : 0);
      // const MOQ = safeNumber(quotation ? quotation.MOQ : 0);
      let price = quotation ? parseFloat(quotation.Price) : 0;
      const MOQ = quotation ? parseFloat(quotation.MOQ) : 0;

      // 🔥 Convert price from INR → Selected Currency
      if (selectedCurrency !== 'INR') {
        price = price / selectedRate;
      }

      // Optional: round to 2 decimals
      price = Number(price.toFixed(2));

      const totalAmount = Number((price * MOQ).toFixed(2));
      const attributes = item.attributes || item;
      const setStatus = attributes.SetStatus || 'Single';

      const innerCount = attributes.Packaging
        ? attributes.Packaging.filter(p => p.CartonType === 'inner').reduce(
            (s, p) => s + safeNumber(p.Carton_PCS),
            0
          )
        : 0;
      const masterCount = attributes.Packaging
        ? attributes.Packaging.filter(p => p.CartonType === 'master').reduce(
            (s, p) => s + safeNumber(p.Carton_PCS),
            0
          )
        : 0;

      const masterCarton = attributes.Packaging?.find(p => p.CartonType === 'master');

      const masterLength = masterCarton
        ? safeNumber(convertDimension(masterCarton.Carton_Length, originalUnit, unit)).toFixed(2)
        : '';
      const masterWidth = masterCarton
        ? safeNumber(convertDimension(masterCarton.Carton_Width, originalUnit, unit)).toFixed(2)
        : '';
      const masterThick = masterCarton
        ? safeNumber(convertDimension(masterCarton.Carton_Thick, originalUnit, unit)).toFixed(2)
        : '';
      const masterCBM = masterCarton ? safeNumber(masterCarton.Carton_CBM).toFixed(4) : '';
      const masterUnit = masterCarton ? unit : '';

      let rowValues;

      if (setStatus === 'Set' && attributes.SetSizes?.length > 0) {
        const allLengths = attributes.SetSizes.map(s =>
          safeNumber(convertDimension(s.Length, originalUnit, unit)).toFixed(2)
        ).join('\n');
        const allWidths = attributes.SetSizes.map(s =>
          safeNumber(convertDimension(s.Width, originalUnit, unit)).toFixed(2)
        ).join('\n');
        const allHeights = attributes.SetSizes.map(s =>
          safeNumber(convertDimension(s.Height, originalUnit, unit)).toFixed(2)
        ).join('\n');
        const allColorFinish = attributes.SetSizes.map(
          s => `${s.ColorName || ''} / ${s.FinishName || ''}`
        ).join('\n');
        const allNetWeights = attributes.SetSizes.map(s => s.NetWt || '').join('\n');
        const sizeUnit = unit || '';

        // swapped Unit and Color/Finish
        rowValues = [
          i + 1,
          attributes.ProductId || '',
          '',
          attributes.Description || '',
          allLengths,
          allWidths,
          allHeights,
          sizeUnit, // Unit (swapped)
          allColorFinish, // Color/Finish (swapped)
          attributes.ProductionDetail?.map(d => d.MaterialNm).join(', ') || '',
          allNetWeights,
          innerCount || '',
          masterCount || '',
          price.toFixed(2),
          attributes.SellingPriceCurrency || '',
          MOQ.toFixed(0),
          masterLength,
          masterWidth,
          masterThick,
          masterUnit,
          'Set',
          masterCBM,
          attributes.Product_Remark || ''
        ];
      } else {
        // single products
        rowValues = [
          i + 1,
          attributes.ProductId || '',
          '',
          attributes.Description || '',
          attributes.Length
            ? safeNumber(convertDimension(attributes.Length, originalUnit, unit)).toFixed(2)
            : '',
          attributes.Width
            ? safeNumber(convertDimension(attributes.Width, originalUnit, unit)).toFixed(2)
            : '',
          attributes.Height
            ? safeNumber(convertDimension(attributes.Height, originalUnit, unit)).toFixed(2)
            : '',
          unit || '', // Unit (swapped)
          `${attributes.ColorName || ''} / ${attributes.FinishName || ''}`, // Color/Finish (swapped)
          attributes.ProductionDetail?.map(d => d.MaterialNm).join(', ') || '',
          attributes.NetWeight || '',
          innerCount || '',
          masterCount || '',
          price.toFixed(2),
          attributes.SellingPriceCurrency || '',
          MOQ.toFixed(0),
          masterLength,
          masterWidth,
          masterThick,
          masterUnit,
          'Pc',
          masterCBM,
          attributes.Product_Remark || ''
        ];
      }

      const row = worksheet.getRow(rowIndex++);
      row.values = rowValues;
      const descriptionText = rowValues[3] || ''; // Column D
      const columnWidth = 50; // Your desired width for Description
      worksheet.getColumn(4).width = columnWidth; // Set column width

      // Calculate number of lines needed
      const approxCharsPerLine = Math.floor(columnWidth * 1.4);
      const linesNeeded = descriptionText
        .split('\n')
        .reduce((sum, line) => sum + Math.ceil(line.length / approxCharsPerLine), 0);
      // row.height = Math.max(30, linesNeeded * 20); // 20px per line is a good balance
      // ---- FIX ROW HEIGHT ----
      const imageHeightPx = 60; // same as image ext height
      const imageRowHeight = imageHeightPx / 1.33;

      const textRowHeight = Math.max(30, linesNeeded * 20);

      // ✅ Ensure row is tall enough for image
      row.height = Math.max(textRowHeight, imageRowHeight + 10);

      row.eachCell((cell, colNumber) => {
        cell.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
      row.commit();

      // Image handling (unchanged)
      const addMergedImageToExcel = async (
        imageUrl,
        watermarkUrl,
        workbook,
        worksheet,
        rowIndex
      ) => {
        const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'jpeg' });
        worksheet.addImage(imageId, {
          tl: { col: 2.1, row: rowIndex - 1.9 },
          ext: { width: 72, height: 60 }
        });
      };

      if (Image && waterMark) {
        const watermarkImageUrl = `${ip}${compdata?.attributes?.WaterMark.data.attributes.url}`;
        await addMergedImageToExcel(Image, watermarkImageUrl, workbook, worksheet, rowIndex);
      } else if (Image) {
        const response = await fetch(Image);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });
        worksheet.addImage(imageId, {
          tl: { col: 2.1, row: rowIndex - 1.9 },
          ext: { width: 72, height: 60 }
        });
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    const base64String = await blobToBase64(blob);
    const fileData = {
      filename: `Quotation_${qutname || 'Document'}.xlsx`,
      blob,
      base64: base64String
    };
    setDownloadedFile(fileData); // keep this if you still need state elsewhere
    saveAs(blob, `Quotation_${qutname || 'Document'}.xlsx`);
    return fileData; // ✅ IMPORTANT
  };

  // Add this helper function
  const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result as string;
        // Remove the data URL prefix if present
        const base64Content = base64.split(',')[1] || base64;
        resolve(base64Content);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const mergeImagesWithWatermark = async (imageUrl, watermarkUrl) => {
    // Load the main image with cross-origin
    const originalImage = new Image();
    originalImage.crossOrigin = 'anonymous'; // Set CORS for the main image
    originalImage.src = imageUrl;
    await new Promise(resolve => {
      originalImage.onload = resolve;
    });

    // Load the watermark image with cross-origin
    const watermarkImage = new Image();
    watermarkImage.crossOrigin = 'anonymous'; // Set CORS for the watermark image
    watermarkImage.src = watermarkUrl;
    await new Promise(resolve => {
      watermarkImage.onload = resolve;
    });

    // Create a canvas to draw both images
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Set canvas size to match the original image
    canvas.width = originalImage.width;
    canvas.height = originalImage.height;

    // Draw the original image on the canvas
    ctx.drawImage(originalImage, 0, 0);

    // Set watermark opacity (optional)
    ctx.globalAlpha = 1; // Adjust this for transparency

    // Draw the watermark image
    ctx.drawImage(watermarkImage, 0, 0, originalImage.width, originalImage.height);

    // Convert the canvas to a base64 string
    const mergedImageBase64 = canvas.toDataURL('image/jpeg'); // Can be png or jpg depending on the format you want

    return mergedImageBase64;
  };

  const [states, setStates] = useState(false);
  const convertDimension = (value, fromUnit, toUnit) => {
    if (!value || isNaN(value)) return value;

    const num = parseFloat(value);

    // Same unit → no conversion
    if (fromUnit === toUnit) return num;

    // cm → inch
    if (fromUnit === 'cm' && toUnit === 'inch') {
      return +(num / 2.54).toFixed(2);
    }

    // inch → cm
    if (fromUnit === 'inch' && toUnit === 'cm') {
      return +(num * 2.54).toFixed(2);
    }

    return num;
  };
  const getUsdToInrRate = async () => {
    try {
      const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
      const data = await res.json();
      return data.rates.INR; // live USD → INR rate
    } catch (error) {
      console.error('Error fetching exchange rate:', error);
      return 1; // fallback
    }
  };
  const convertCmToInch = value => {
    if (!value) return value;
    return (parseFloat(value) / 2.54).toFixed(2);
  };
  const downloadExcelData1 = async (data, unit = 'cm', currency = 'USD') => {
    // Initialize workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Quotation', {
      properties: { tabColor: { argb: 'FFC00000' } }
    });

    const compname = compdata?.attributes?.cmpnm;
    const country = compdata?.attributes?.country;
    const address = compdata?.attributes?.address;
    const email = compdata?.attributes?.email_id;
    const contactno = compdata?.attributes?.contactno;
    const contactperson = compdata?.attributes?.ContactDetail.map(detail => detail.Name).join(', ');
    const personmobile = compdata?.attributes?.ContactDetail.map(detail => detail.mobileno).join(
      ', '
    );

    // Merge cells for quotation/company name
    worksheet.mergeCells('A1:AB2');
    const headerCell = worksheet.getCell('A1');
    headerCell.value = 'Quotation';
    headerCell.alignment = { vertical: 'middle', horizontal: 'center' };
    headerCell.font = { size: 16, bold: true };
    headerCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCE5FF' }
    };

    // Merge cells for vendor details block (left box)
    worksheet.mergeCells('A3:I7');
    const vendorCell = worksheet.getCell('A3');
    vendorCell.value = `Vendor Name: ${compname}\nCountry: ${country}\nAddress: ${address}\nContact Person: ${contactperson}\nOffice Tel No.: ${contactno}\nMobile No.: ${personmobile}\nEmail: ${email}`;
    vendorCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
    vendorCell.font = { size: 10 };
    vendorCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF' }
    };
    vendorCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Merge cells for buyer details block (middle box)
    worksheet.mergeCells('J3:O7');
    const buyerCell = worksheet.getCell('J3');
    buyerCell.value = `Buyer Name: ${bname}\nTel: ${'N/A'}`;
    buyerCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
    buyerCell.font = { size: 10 };
    buyerCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF' }
    };
    buyerCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Merge cells for quotation details block (right box)
    worksheet.mergeCells('P3:AB7');
    const quotationCell = worksheet.getCell('P3');
    quotationCell.value = `Quotation Date: ${qdate}\nPayment Terms: ${'N/A'}\nProduction Lead Time: ${'N/A'}\nPrice Terms: ${'N/A'}\nPort of Loading: ${'N/A'}`;
    quotationCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
    quotationCell.font = { size: 10 };
    quotationCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF' }
    };
    quotationCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Add headers with colspan effect starting from row 8
    worksheet.mergeCells('F8:H8'); // Merge for Dimensions (L x W x H)
    worksheet.getCell('F8').value = 'Dimensions';
    worksheet.getCell('F8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('F8').font = { bold: true };

    worksheet.mergeCells('L8:M8'); // Merge for Carton
    worksheet.getCell('L8').value = 'Catron Qty';
    worksheet.getCell('L8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('L8').font = { bold: true };

    worksheet.mergeCells('Q8:S8'); // Merge for Carton Size
    worksheet.getCell('Q8').value = 'Carton Size';
    worksheet.getCell('Q8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('Q8').font = { bold: true };

    worksheet.mergeCells('U8:V8'); // Merge for Total
    worksheet.getCell('U8').value = 'Total';
    worksheet.getCell('U8').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('U8').font = { bold: true };

    if (states) {
      worksheet.mergeCells('AE8:AJ8');
      worksheet.getCell('AE8').value = 'Lighting Specification';
      worksheet.getCell('AE8').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('AE8').font = { bold: true };

      worksheet.mergeCells('AK8:AM8');
      worksheet.getCell('AK8').value = 'Item Dimension';
      worksheet.getCell('AK8').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('AK8').font = { bold: true };

      worksheet.mergeCells('AQ8:AU8');
      worksheet.getCell('AQ8').value = 'Lamp Shape Info';
      worksheet.getCell('AQ8').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('AQ8').font = { bold: true };

      worksheet.mergeCells('AV8:AX8');
      worksheet.getCell('AV8').value = 'Item Dimension';
      worksheet.getCell('AV8').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('AV8').font = { bold: true };
    }

    // Add remaining headers in row 8
    worksheet.mergeCells('A8:A9'); // Sr No.
    worksheet.mergeCells('B8:B9'); // Supp. Item No.
    worksheet.mergeCells('C8:C9'); // Image
    worksheet.mergeCells('D8:D9'); // Alias Code
    worksheet.mergeCells('E8:E9'); // Description
    worksheet.mergeCells('I8:I9'); // Color/Finish
    worksheet.mergeCells('J8:J9'); // Material
    worksheet.mergeCells('K8:K9'); // Net Wt
    worksheet.mergeCells('N8:N9'); // FOB
    worksheet.mergeCells('O8:O9'); // MOQ
    worksheet.mergeCells('P8:P9'); // Total amount
    worksheet.mergeCells('T8:T9'); // Unit (NEW - added after Carton Size)
    worksheet.mergeCells('W8:W9'); // CBM/CTN
    worksheet.mergeCells('X8:X9'); // Pack Detail
    worksheet.mergeCells('Y8:Y9'); // Care In
    worksheet.mergeCells('Z8:Z9'); // Assembly
    worksheet.mergeCells('AA8:AA9'); // Unit
    worksheet.mergeCells('AB8:AB9'); // Remarks

    if (states) {
      worksheet.mergeCells('AC8:AC9');
      worksheet.mergeCells('AD8:AD9');
      worksheet.mergeCells('AE8:AE9');
    }

    worksheet.getCell('A8').value = 'Sr No.';
    worksheet.getCell('B8').value = 'Supp.\nItem No.';
    worksheet.getCell('C8').value = 'Image';
    worksheet.getCell('D8').value = 'Buyer SKU';
    worksheet.getCell('E8').value = 'Description';
    worksheet.getCell('I8').value = 'Color/Finish';
    worksheet.getCell('J8').value = 'Materials Used';
    worksheet.getCell('K8').value = 'Net Weight';
    worksheet.getCell('N8').value = `F.O.B Unit Price (${selectedCurrency || 'INR'})`;
    worksheet.getCell('O8').value = 'MOQ';
    worksheet.getCell('P8').value = 'Total Amount';
    worksheet.getCell('T8').value = `Unit`;
    worksheet.getCell('W8').value = 'CBM/CNT';
    worksheet.getCell('X8').value = 'Packaging Details';
    worksheet.getCell('Y8').value = 'Care Instruction';
    worksheet.getCell('Z8').value = 'Assembly Time';
    worksheet.getCell('AA8').value = 'Unit(Set/Pc)';
    worksheet.getCell('AB8').value = 'Remarks';

    if (states) {
      worksheet.getCell('AC8').value = 'Product Warranty';
      worksheet.getCell('AD8').value = 'Metal Finish/\ntechnique method';
      worksheet.getCell('AE8').value = 'Specific Material Information';
    }

    // Subheaders for Dimensions (row 9)
    worksheet.getCell('F9').value = 'L';
    worksheet.getCell('G9').value = 'W';
    worksheet.getCell('H9').value = 'H';

    worksheet.getCell('L9').value = 'Inner';
    worksheet.getCell('M9').value = 'Master';

    worksheet.getCell('Q9').value = 'L';
    worksheet.getCell('R9').value = 'W';
    worksheet.getCell('S9').value = 'H';

    worksheet.getCell('U9').value = 'CBM';
    worksheet.getCell('V9').value = 'CTN';

    if (states) {
      worksheet.getCell('AF9').value = 'Holder';
      worksheet.getCell('AG9').value = 'No. of lights';
      worksheet.getCell('AH9').value = 'Bulb Fitting';
      worksheet.getCell('AI9').value = 'Bulbs included?';
      worksheet.getCell('AJ9').value = 'Max Watts Capacity per Bulb';
      worksheet.getCell('AK9').value = 'Voltage';

      worksheet.getCell('AL9').value = 'Length';
      worksheet.getCell('AM9').value = 'Width';
      worksheet.getCell('AN9').value = 'Height';

      worksheet.getCell('AO8').value = 'Size (cm)';
      worksheet.getCell('AO9').value = 'Height';
      worksheet.getCell('AP8').value = 'Adjustable Height?';
      worksheet.getCell('AP9').value = 'Yes/No';

      worksheet.getCell('AQ8').value = 'Size (cm)';
      worksheet.getCell('AQ9').value = 'Length';

      worksheet.getCell('AR9').value = 'Fabric';
      worksheet.getCell('AS9').value = 'Colour';
      worksheet.getCell('AT9').value = 'Length';
      worksheet.getCell('AU9').value = 'Width';
      worksheet.getCell('AV9').value = 'Height';

      worksheet.getCell('AW9').value = 'Length';
      worksheet.getCell('AX9').value = 'Width';
      worksheet.getCell('AY9').value = 'Height';
    }

    // Apply styles for headers
    const headerRow1 = worksheet.getRow(8);
    const headerRow2 = worksheet.getRow(9);

    [headerRow1, headerRow2].forEach(row => {
      row.eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF000000' }
        };
        cell.font = {
          bold: true,
          color: { argb: 'FFFFFFFF' },
          size: 10
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
        };
      });
    });

    // Adjust column widths
    worksheet.columns = [
      { width: 6 }, // Sr No.
      { width: 15 }, // Supp. Item No.
      { width: 12 }, // Image
      { width: 12 }, // Alias Code
      { width: 50 }, // Description
      { width: 5 }, // Length
      { width: 5 }, // Width
      { width: 5 }, // Height
      { width: 14 }, // Color/Finish
      { width: 18 }, // Materials
      { width: 15 }, // Net Wt
      { width: 8 }, // Inner
      { width: 8 }, // Master
      { width: 25 }, // FOB
      { width: 10 }, // MOQ
      { width: 14 }, // T Amount
      { width: 5 }, // L
      { width: 5 }, // W
      { width: 5 }, // H
      { width: 10 }, // Unit (NEW - Carton Unit)
      { width: 6 }, // CBM
      { width: 6 }, // CTN
      { width: 10 }, // CBM/CNT
      { width: 16 }, // Packaging
      { width: 15 }, // Care
      { width: 15 }, // Assembly
      { width: 12 }, // Unit(Set/Pc)
      { width: 10 }, // Remark
      ...(!states
        ? Array(6).fill({ width: 0 })
        : [
            { width: 20 },
            { width: 27 },
            { width: 25 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 20 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 },
            { width: 10 }
          ])
    ];

    // Populate data rows starting from row 10
    let rowIndex = 10;
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      const { Image, Length, Width, Height, NetWeight } = item;
      const originalUnit = item.SizeUnit?.toLowerCase() === 'inch' ? 'inch' : 'cm';

      const quotation = qdata.find(q => q.QuotationProductcode == item.id);
      // const price = quotation ? parseFloat(quotation.Price) : 0;
      // const MOQ = quotation ? parseFloat(quotation.MOQ) : 0;
      // const totalAmount = price * MOQ;
      let price = quotation ? parseFloat(quotation.Price) : 0;
      const MOQ = quotation ? parseFloat(quotation.MOQ) : 0;

      // 🔥 Convert price from INR → Selected Currency
      if (selectedCurrency !== 'INR') {
        price = price / selectedRate;
      }

      // Optional: round to 2 decimals
      price = Number(price.toFixed(2));

      const totalAmount = Number((price * MOQ).toFixed(2));
      const masterCount = item.Packaging
        ? item.Packaging.filter(pack => pack.CartonType === 'master').length
        : 0;
      const innerCount = item.Packaging
        ? item.Packaging.filter(pack => pack.CartonType === 'inner').length
        : 0;

      const masterCarton = item.Packaging
        ? item.Packaging.find(pack => pack.CartonType === 'master')
        : null;

      const masterLength = masterCarton ? masterCarton.Carton_Length : '';
      const masterWidth = masterCarton ? masterCarton.Carton_Width : '';
      const masterThick = masterCarton ? masterCarton.Carton_Thick : '';
      const Carton_CBM = masterCarton ? masterCarton.Carton_CBM : '';
      const Carton_PCS = masterCarton ? masterCarton.Carton_PCS : '';
      const Carton_CBMperpc = masterCarton ? masterCarton.Carton_CBMperpc : '';
      const masterUnit = masterCarton ? unit : ''; // NEW - Get carton unit

      const unitType = masterCount === 1 && innerCount <= 1 ? 'Pc' : 'Set';

      const row = worksheet.getRow(rowIndex++);
      row.values = [
        i + 1,
        item.ProductId || '',
        '',
        item.BuyerSku || '',
        item.Description || '',
        convertDimension(Length, originalUnit, unit) || '',
        convertDimension(Width, originalUnit, unit) || '',
        convertDimension(Height, originalUnit, unit) || '',
        `${item.ColorName}/\n${item.FinishName}` || '',
        item.ProductionDetail
          ? item.ProductionDetail.map(detail => detail.MaterialNm).join(', ')
          : '',
        NetWeight || '',
        innerCount || '',
        masterCount || '',
        parseFloat(quotation.Price) || '',
        parseFloat(quotation.MOQ) || '',
        totalAmount.toFixed(2) || '',
        convertDimension(masterLength, originalUnit, unit) || '',
        convertDimension(masterWidth, originalUnit, unit) || '',
        convertDimension(masterThick, originalUnit, unit) || '',

        masterUnit || '', // NEW - Carton Unit value
        Carton_PCS || '',
        Carton_CBMperpc || '',
        Carton_CBM || '',
        '', // Packaging Details
        '', // Care Instruction
        '', // Assembly Time
        unitType || '',
        item.Product_Remark || '',
        ...(states
          ? [
              '',
              '',
              '',
              'Holder',
              'No. of lights',
              'Bulb Fitting',
              'Bulbs included?',
              'Max Watts Capacity per Bulb',
              'Voltage',
              '',
              '',
              '',
              'w',
              'q',
              'l',
              'l1',
              'l2',
              'l3',
              'l4',
              'l5',
              'L',
              'W',
              'H'
            ]
          : Array(6).fill(''))
      ];

      const descriptionText = row.values[5] || row.values[4];
      const columnWidth = worksheet.getColumn(5).width;
      const approxCharsPerLine = Math.floor(columnWidth * 1.4);
      const linesNeeded = descriptionText
        .toString()
        .split('\n')
        .reduce((sum, line) => sum + Math.ceil(line.length / approxCharsPerLine), 0);

      let textHeight = Math.max(20, linesNeeded * 20);
      const imageHeightPx = 60;
      const imageRowHeight = imageHeightPx / 1.1;

      row.height = Math.max(textHeight, imageRowHeight);

      row.eachCell(cell => {
        cell.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
      row.commit();

      const addMergedImageToExcel = async (
        imageUrl,
        watermarkUrl,
        workbook,
        worksheet,
        rowIndex
      ) => {
        const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: 'jpeg'
        });
        worksheet.addImage(imageId, {
          tl: { col: 2.1, row: rowIndex - 1.9 },
          ext: { width: 72, height: 60 }
        });
      };

      if (Image && waterMark) {
        const watermarkImageUrl = `${ip}${compdata?.attributes?.WaterMark.data.attributes.url}`;
        await addMergedImageToExcel(Image, watermarkImageUrl, workbook, worksheet, rowIndex);
      } else {
        const response = await fetch(Image);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: 'png'
        });
        worksheet.addImage(imageId, {
          tl: { col: 2.1, row: rowIndex - 1.9 },
          ext: { width: 72, height: 60 }
        });
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(blob, `${'Quotation'}.xlsx`);
  };
  // const downloadExcelData1 = async data => {
  //   // Initialize workbook and worksheet
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Quotation', {
  //     properties: { tabColor: { argb: 'FFC00000' } }
  //   });

  //   const compname = compdata?.attributes?.cmpnm;
  //   const country = compdata?.attributes?.country;
  //   const address = compdata?.attributes?.address;
  //   const email = compdata?.attributes?.email_id;
  //   const contactno = compdata?.attributes?.contactno;
  //   const contactperson = compdata?.attributes?.ContactDetail.map(detail => detail.Name).join(', ');
  //   const personmobile = compdata?.attributes?.ContactDetail.map(detail => detail.mobileno).join(
  //     ', '
  //   );

  //   // Merge cells for quotation/company name
  //   worksheet.mergeCells('A1:AA2');
  //   const headerCell = worksheet.getCell('A1');
  //   headerCell.value = 'Quotation';
  //   headerCell.alignment = { vertical: 'middle', horizontal: 'center' };
  //   headerCell.font = { size: 16, bold: true };
  //   headerCell.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: 'FFCCE5FF' } // Light yellow background
  //   };

  //   // Merge cells for vendor details block (left box)
  //   worksheet.mergeCells('A3:I7'); // Adjusted range for left box
  //   const vendorCell = worksheet.getCell('A3');
  //   vendorCell.value = `Vendor Name: ${compname}\nCountry: ${country}\nAddress: ${address}\nContact Person: ${contactperson}\nOffice Tel No.: ${contactno}\nMobile No.: ${personmobile}\nEmail: ${email}`;
  //   vendorCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
  //   vendorCell.font = { size: 10 };
  //   vendorCell.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: 'FFFFFF' } // Light gray background
  //   };
  //   vendorCell.border = {
  //     top: { style: 'thin' },
  //     left: { style: 'thin' },
  //     bottom: { style: 'thin' },
  //     right: { style: 'thin' }
  //   };

  //   // Merge cells for buyer details block (middle box)
  //   worksheet.mergeCells('J3:O7'); // Adjusted range for middle box
  //   const buyerCell = worksheet.getCell('J3');
  //   buyerCell.value = `Buyer Name: ${bname}\nTel: ${'N/A'}`;
  //   buyerCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
  //   buyerCell.font = { size: 10 };
  //   buyerCell.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: 'FFFFFF' } // Light blue background
  //   };
  //   buyerCell.border = {
  //     top: { style: 'thin' },
  //     left: { style: 'thin' },
  //     bottom: { style: 'thin' },
  //     right: { style: 'thin' }
  //   };

  //   // Merge cells for quotation details block (right box)
  //   worksheet.mergeCells('P3:AA7'); // Adjusted range for right box
  //   const quotationCell = worksheet.getCell('P3');
  //   quotationCell.value = `Quotation Date: ${qdate}\nPayment Terms: ${'N/A'}\nProduction Lead Time: ${'N/A'}\nPrice Terms: ${'N/A'}\nPort of Loading: ${'N/A'}`;
  //   quotationCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
  //   quotationCell.font = { size: 10 };
  //   quotationCell.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: 'FFFFFF' } // Light yellow background
  //   };
  //   quotationCell.border = {
  //     top: { style: 'thin' },
  //     left: { style: 'thin' },
  //     bottom: { style: 'thin' },
  //     right: { style: 'thin' }
  //   };
  //   // Add headers with colspan effect starting from row 8
  //   worksheet.mergeCells('F8:H8'); // Merge for Dimensions (L x W x H)
  //   worksheet.getCell('F8').value = 'Dimensions';
  //   worksheet.getCell('F8').alignment = { vertical: 'middle', horizontal: 'center' };
  //   worksheet.getCell('F8').font = { bold: true };

  //   worksheet.mergeCells('L8:M8'); // Merge for Carton
  //   worksheet.getCell('L8').value = 'Catron Qty';
  //   worksheet.getCell('L8').alignment = { vertical: 'middle', horizontal: 'center' };
  //   worksheet.getCell('L8').font = { bold: true };

  //   worksheet.mergeCells('Q8:S8'); // Merge for Dimensions (L x W x H)
  //   worksheet.getCell('Q8').value = 'Carton Size';
  //   worksheet.getCell('Q8').alignment = { vertical: 'middle', horizontal: 'center' };
  //   worksheet.getCell('Q8').font = { bold: true };

  //   worksheet.mergeCells('U8:V8'); // Merge for Dimensions (L x W x H)
  //   worksheet.getCell('U8').value = 'Total';
  //   worksheet.getCell('U8').alignment = { vertical: 'middle', horizontal: 'center' };
  //   worksheet.getCell('U8').font = { bold: true };

  //   if (states) {
  //     worksheet.mergeCells('AE8:AJ8'); // Merge for Dimensions (L x W x H)
  //     worksheet.getCell('AE8').value = 'Lighting Specification';
  //     worksheet.getCell('AE8').alignment = { vertical: 'middle', horizontal: 'center' };
  //     worksheet.getCell('AE8').font = { bold: true };

  //     worksheet.mergeCells('AK8:AM8'); // Merge for Dimensions (L x W x H)
  //     worksheet.getCell('AK8').value = 'Item Dimension';
  //     worksheet.getCell('AK8').alignment = { vertical: 'middle', horizontal: 'center' };
  //     worksheet.getCell('AK8').font = { bold: true };

  //     worksheet.mergeCells('AQ8:AU8'); // Merge for Dimensions (L x W x H)
  //     worksheet.getCell('AQ8').value = 'Lamp Shape Info';
  //     worksheet.getCell('AQ8').alignment = { vertical: 'middle', horizontal: 'center' };
  //     worksheet.getCell('AQ8').font = { bold: true };

  //     worksheet.mergeCells('AV8:AX8'); // Merge for Dimensions (L x W x H)
  //     worksheet.getCell('AV8').value = 'Item Dimension';
  //     worksheet.getCell('AV8').alignment = { vertical: 'middle', horizontal: 'center' };
  //     worksheet.getCell('AV8').font = { bold: true };
  //   }
  //   // Add remaining headers in row 8
  //   worksheet.mergeCells('A8:A9'); // Sr No.
  //   worksheet.mergeCells('B8:B9'); // Supp. Item No.
  //   worksheet.mergeCells('C8:C9'); // Image
  //   worksheet.mergeCells('D8:D9'); // Alias Code
  //   worksheet.mergeCells('E8:E9'); // Description
  //   worksheet.mergeCells('I8:I9'); // Color/Finish
  //   worksheet.mergeCells('J8:J9'); // Material
  //   worksheet.mergeCells('K8:K9'); // Net Wt
  //   worksheet.mergeCells('N8:N9'); // FOB
  //   worksheet.mergeCells('O8:O9'); // MOQ
  //   worksheet.mergeCells('P8:P9'); // Total amount
  //   worksheet.mergeCells('T8:T9'); // CBM/CTN
  //   worksheet.mergeCells('W8:W9'); // Pack Detail
  //   worksheet.mergeCells('X8:X9'); // Care In
  //   worksheet.mergeCells('Y8:Y9'); // Assembly
  //   worksheet.mergeCells('Z8:Z9'); // Unit
  //   worksheet.mergeCells('AA8:AA9'); // Remarks

  //   if (states) {
  //     worksheet.mergeCells('AB8:AB9'); // Remarks
  //     worksheet.mergeCells('AC8:AC9'); // Remarks
  //     worksheet.mergeCells('AD8:AD9'); // Remarks
  //   }

  //   worksheet.getCell('A8').value = 'Sr No.';
  //   worksheet.getCell('B8').value = 'Supp.\nItem No.';
  //   worksheet.getCell('C8').value = 'Image';
  //   worksheet.getCell('D8').value = 'Buyer SKU';
  //   worksheet.getCell('E8').value = 'Description';
  //   worksheet.getCell('I8').value = 'Color/Finish';
  //   worksheet.getCell('J8').value = 'Materials Used';
  //   worksheet.getCell('K8').value = 'Net Weight';
  //   worksheet.getCell('N8').value = 'F.O.B Unit Price';
  //   worksheet.getCell('O8').value = 'MOQ';
  //   worksheet.getCell('P8').value = 'Total Amount';
  //   worksheet.getCell('T8').value = 'CBM/CNT';
  //   worksheet.getCell('W8').value = 'Packaging Details';
  //   worksheet.getCell('X8').value = 'Care Instruction';
  //   worksheet.getCell('Y8').value = 'Assembly Time';
  //   worksheet.getCell('Z8').value = 'Unit(Set/Pc)';
  //   worksheet.getCell('AA8').value = 'Remarks';
  //   if (states) {
  //     worksheet.getCell('AB8').value = 'Product Warranty';
  //     worksheet.getCell('AC8').value = 'Metal Finish/\ntechnique method';
  //     worksheet.getCell('AD8').value = 'Specific Material Information';
  //   }
  //   // Subheaders for Dimensions (row 9)
  //   worksheet.getCell('F9').value = 'L';
  //   worksheet.getCell('G9').value = 'W';
  //   worksheet.getCell('H9').value = 'H';

  //   worksheet.getCell('L9').value = 'Inner';
  //   worksheet.getCell('M9').value = 'Master';

  //   worksheet.getCell('Q9').value = 'L';
  //   worksheet.getCell('R9').value = 'W';
  //   worksheet.getCell('S9').value = 'H';

  //   worksheet.getCell('U9').value = 'CBM';
  //   worksheet.getCell('V9').value = 'CTN';

  //   if (states) {
  //     worksheet.getCell('AE9').value = 'Holder';
  //     worksheet.getCell('AF9').value = 'No. of lights';
  //     worksheet.getCell('AG9').value = 'Bulb Fitting';
  //     worksheet.getCell('AH9').value = 'Bulbs included?';
  //     worksheet.getCell('AI9').value = 'Max Watts Capacity per Bulb';
  //     worksheet.getCell('AJ9').value = 'Voltage';

  //     worksheet.getCell('AK9').value = 'Length';
  //     worksheet.getCell('AL9').value = 'Width';
  //     worksheet.getCell('AM9').value = 'Height';

  //     worksheet.getCell('AN8').value = 'Size (cm)';
  //     worksheet.getCell('AN9').value = 'Height';
  //     worksheet.getCell('AO8').value = 'Adjustable Height?';
  //     worksheet.getCell('AO9').value = 'Yes/No';

  //     worksheet.getCell('AP8').value = 'Size (cm)';
  //     worksheet.getCell('AP9').value = 'Length';

  //     worksheet.getCell('AQ9').value = 'Fabric';
  //     worksheet.getCell('AR9').value = 'Colour';
  //     worksheet.getCell('AS9').value = 'Length';
  //     worksheet.getCell('AT9').value = 'Width';
  //     worksheet.getCell('AU9').value = 'Height';

  //     worksheet.getCell('AV9').value = 'Length';
  //     worksheet.getCell('AW9').value = 'Width';
  //     worksheet.getCell('AX9').value = 'Height';
  //   }
  //   // Apply styles for headers
  //   const headerRow1 = worksheet.getRow(8); // First row of headers
  //   const headerRow2 = worksheet.getRow(9); // Subheaders for Dimensions

  //   [headerRow1, headerRow2].forEach(row => {
  //     row.eachCell(cell => {
  //       cell.fill = {
  //         type: 'pattern',
  //         pattern: 'solid',
  //         fgColor: { argb: 'FF000000' } // Black background
  //       };
  //       cell.font = {
  //         bold: true,
  //         color: { argb: 'FFFFFFFF' }, // White font
  //         size: 10
  //       };
  //       cell.alignment = { vertical: 'middle', horizontal: 'center' };
  //       cell.border = {
  //         top: { style: 'thin', color: { argb: 'FFFFFFFF' } }, // White border
  //         left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
  //         bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
  //         right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
  //       };
  //     });
  //   });

  //   // Adjust column widths
  //   worksheet.columns = [
  //     { width: 6 }, // Sr No.
  //     { width: 15 }, // Supp. Item No.
  //     { width: 12 }, // Image
  //     { width: 12 }, // Alias Code
  //     { width: 50 }, // Description
  //     { width: 5 }, // Length
  //     { width: 5 }, // Width
  //     { width: 5 }, // Height
  //     { width: 14 }, // Color/Finish
  //     { width: 18 }, // Materials
  //     { width: 15 }, // Net Wt
  //     { width: 8 }, // Inner
  //     { width: 8 }, // Master
  //     { width: 15 }, // FOB
  //     { width: 10 }, // MOQ
  //     { width: 14 }, // T Amount
  //     { width: 5 }, // L
  //     { width: 5 }, // W
  //     { width: 5 }, // H
  //     { width: 10 }, // CBM/CNT
  //     { width: 6 }, // CBM
  //     { width: 6 }, // CTN
  //     { width: 16 }, // Packaging
  //     { width: 15 }, // Care
  //     { width: 15 }, // Assambly
  //     { width: 12 }, // Unit
  //     { width: 10 }, // Remark
  //     ...(!states
  //       ? Array(6).fill({ width: 0 }) // Hide Lighting Specification columns if not visible
  //       : [
  //         { width: 20 }, // Remark
  //         { width: 27 }, // Remark
  //         { width: 25 }, // Remark
  //         { width: 10 }, // Holder
  //         { width: 10 }, // No. of lights
  //         { width: 10 }, // Bulb Fitting
  //         { width: 10 }, // Bulbs included?
  //         { width: 10 }, // Max Watts Capacity per Bulb
  //         { width: 10 }, // Voltage
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 20 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 }, // Remark
  //         { width: 10 } // Remark
  //       ])
  //   ];

  //   // Populate data rows starting from row 9 (headers span rows 7 and 8)
  //   let rowIndex = 10;
  //   for (let i = 0; i < data.length; i++) {
  //     const item = data[i];
  //     const { Image, Length, Width, Height, NetWeight } = item;
  //     const quotation = qdata.find(q => q.QuotationProductcode == item.id);
  //     // Get Price and MOQ from qdata if a match is found
  //     const price = quotation ? parseFloat(quotation.Price) : 0;
  //     const MOQ = quotation ? parseFloat(quotation.MOQ) : 0;
  //     // Calculate totalAmount using matched qdata
  //     const totalAmount = price * MOQ;

  //     // Count master and inner carton types in Packaging
  //     const masterCount = item.Packaging
  //       ? item.Packaging.filter(pack => pack.CartonType === 'master').length
  //       : 0;
  //     const innerCount = item.Packaging
  //       ? item.Packaging.filter(pack => pack.CartonType === 'inner').length
  //       : 0;

  //     const masterCarton = item.Packaging
  //       ? item.Packaging.find(pack => pack.CartonType === 'master')
  //       : null;

  //     const masterLength = masterCarton ? masterCarton.Carton_Length : '';
  //     const masterWidth = masterCarton ? masterCarton.Carton_Width : '';
  //     const masterThick = masterCarton ? masterCarton.Carton_Thick : '';

  //     const Carton_CBM = masterCarton ? masterCarton.Carton_CBM : '';
  //     const Carton_PCS = masterCarton ? masterCarton.Carton_PCS : '';
  //     const Carton_CBMperpc = masterCarton ? masterCarton.Carton_CBMperpc : '';

  //     const unitType = masterCount === 1 && innerCount <= 1 ? 'Pc' : 'Set';

  //     const row = worksheet.getRow(rowIndex++);
  //     row.values = [
  //       i + 1, // Sr No.
  //       item.ProductId || '', // Supp. Item No.
  //       '', // Placeholder for image
  //       item.BuyerSku || '', // Alias Code
  //       item.Description || '', // Description
  //       Length || '', // Length
  //       Width || '', // Width
  //       Height || '', // Height
  //       `${item.ColorName}/\n${item.FinishName}` || '', // Color/Finish
  //       item.ProductionDetail
  //         ? item.ProductionDetail.map(detail => detail.MaterialNm).join(', ')
  //         : '',
  //       NetWeight || '', // NetWeight
  //       innerCount || '',
  //       masterCount || '',
  //       parseFloat(quotation.Price) || '',
  //       parseFloat(quotation.MOQ) || '',
  //       totalAmount.toFixed(2) || '',
  //       masterLength || '',
  //       masterWidth || '',
  //       masterThick || '',
  //       Carton_CBM || '',
  //       Carton_PCS || '',
  //       Carton_CBMperpc || '',
  //       '', // CM
  //       '', // CM
  //       '', // CM
  //       unitType || '', // CM
  //       item.Product_Remark || '', // CM
  //       ...(states
  //         ? [
  //           '', // CM
  //           '', // CM
  //           '', // CM
  //           'Holder', // Lighting Specification
  //           'No. of lights',
  //           'Bulb Fitting',
  //           'Bulbs included?',
  //           'Max Watts Capacity per Bulb',
  //           'Voltage',
  //           // Fill with empty strings if hidden
  //           '', // CM
  //           '', // CM
  //           '', // CM
  //           'w', // CM
  //           'q', // CM
  //           'l', // CM
  //           'l1', // CM
  //           'l2', // CM
  //           'l3', // CM
  //           'l4', // CM
  //           'l5', // CM
  //           'L', // CM
  //           'W', // CM
  //           'H'
  //         ]
  //         : Array(6).fill('')) // CM
  //     ];
  //     // Inside your loop after setting row.values
  //     const descriptionText = row.values[5] || row.values[4]; // Column E (Description)
  //     const columnWidth = worksheet.getColumn(5).width; // Column E
  //     const approxCharsPerLine = Math.floor(columnWidth * 1.4);
  //     const linesNeeded = descriptionText
  //       .toString()
  //       .split('\n')
  //       .reduce((sum, line) => sum + Math.ceil(line.length / approxCharsPerLine), 0);

  //     // Calculate height based on text
  //     let textHeight = Math.max(20, linesNeeded * 20);
  //     const imageHeightPx = 60; // same as image ext height
  //     const imageRowHeight = imageHeightPx / 1.1;
  //     // Calculate height based on image

  //     // Set row height to the max of text height or image height
  //     row.height = Math.max(textHeight, imageRowHeight);

  //     // Add border and alignment to each cell
  //     row.eachCell(cell => {
  //       cell.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
  //       cell.border = {
  //         top: { style: 'thin' },
  //         left: { style: 'thin' },
  //         bottom: { style: 'thin' },
  //         right: { style: 'thin' }
  //       };
  //     });
  //     row.commit();

  //     const addMergedImageToExcel = async (imageUrl, watermarkUrl, workbook, worksheet, rowIndex) => {
  //       // Merge the original image and watermark
  //       const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

  //       // Convert Base64 to ArrayBuffer
  //       const response = await fetch(mergedImageBase64);
  //       const imageBuffer = await response.arrayBuffer();

  //       // Add the merged image to the worksheet
  //       const imageId = workbook.addImage({
  //         buffer: imageBuffer,
  //         extension: 'jpeg',
  //       });

  //       // Add the image to the worksheet at the specified position
  //       worksheet.addImage(imageId, {
  //         tl: { col: 2.1, row: rowIndex - 1.9 }, // Adjusted to align image inside the cell
  //         ext: { width: 72, height: 60 }, // Image dimensions to fit cell
  //       });
  //     };

  //     // Add image to the second column
  //     if (Image && waterMark) {
  //       const watermarkImageUrl = `${ip}${compdata?.attributes?.WaterMark.data.attributes.url}`;
  //       await addMergedImageToExcel(Image, watermarkImageUrl, workbook, worksheet, rowIndex);
  //     }
  //     else {
  //       const response = await fetch(Image);
  //       const imageBuffer = await response.arrayBuffer();
  //       const imageId = workbook.addImage({
  //         buffer: imageBuffer,
  //         extension: 'png'
  //       });
  //       worksheet.addImage(imageId, {
  //         tl: { col: 2.1, row: rowIndex - 1.9 }, // Adjusted to align image inside the cell
  //         ext: { width: 72, height: 60 } // Image dimensions to fit cell
  //       });

  //     }
  //   }
  //   // Generate Excel file and save
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  //   });
  //   saveAs(blob, `${'Quotation'}.xlsx`);
  // };

  const generatePDF3 = (data, qdata, unit) => {
    const doc = new jsPDF('landscape');

    let startX = 2;
    let startY = 15;
    let rowHeight = 23;
    let colWidthBig = 112;
    let colWidthBig1 = 185;
    let colWidthNormal = 73;
    let colWidthNormal1 = 108;

    const compname = compdata?.attributes?.cmpnm || 'No Company Name';
    const waterMarkURL = compdata?.attributes?.WaterMark?.data?.attributes?.url || '';
    const country = compdata?.attributes?.country || 'Unknown Country';
    const maddress = compdata?.attributes?.address || 'Unknown Address';
    const contactperson =
      compdata?.attributes?.ContactDetail?.map(detail => detail.Name).join(', ') ||
      'No Contact Person';
    const personmobile =
      compdata?.attributes?.ContactDetail?.map(detail => detail.mobileno).join(', ') || 'No Mobile';
    const personemail =
      compdata?.attributes?.ContactDetail?.map(detail => detail.email).join(', ') || 'No Email';

    // Header
    doc.setFontSize(18);
    const textWidth = doc.getTextWidth(compname);
    const pageWidth = doc.internal.pageSize.width;
    const centerX = (pageWidth - textWidth) / 2;
    doc.text('Quotation', centerX, 10);

    // Draw cells
    doc.setDrawColor(0, 0, 0);
    doc.rect(startX, 2, 293, 13);
    doc.rect(startX, startY, colWidthBig, rowHeight);

    // Vendor Details
    // Vendor Details
    let yPos = 18; // starting Y position

    // Vendor Name
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text('Vendor Name:', 3, yPos);
    doc.setFont('helvetica', 'normal');
    const vendorNameText = doc.splitTextToSize(compname, 80);
    doc.text(vendorNameText, 23, yPos);
    yPos += vendorNameText.length * 3; // adjust Y for next line

    // Country
    doc.setFont('helvetica', 'bold');
    doc.text('Country:', 3, yPos);
    doc.setFont('helvetica', 'normal');
    const countryText = doc.splitTextToSize(country, 80);
    doc.text(countryText, 23, yPos);
    yPos += countryText.length * 3;

    // Address
    doc.setFont('helvetica', 'bold');
    doc.text('Address:', 3, yPos);
    doc.setFont('helvetica', 'normal');
    const addressText = doc.splitTextToSize(maddress, 80);
    doc.text(addressText, 23, yPos);
    yPos += addressText.length * 3;

    // Contact Person
    doc.setFont('helvetica', 'bold');
    doc.text('Contact Person:', 3, yPos);
    doc.setFont('helvetica', 'normal');
    const contactPersonText = doc.splitTextToSize(contactperson, 80);
    doc.text(contactPersonText, 23, yPos);
    yPos += contactPersonText.length * 3;

    // Mobile No
    doc.setFont('helvetica', 'bold');
    doc.text('Mobile No:', 3, yPos);
    doc.setFont('helvetica', 'normal');
    const mobileText = doc.splitTextToSize(personmobile, 80);
    doc.text(mobileText, 23, yPos);
    yPos += mobileText.length * 3;

    // Email Address
    doc.setFont('helvetica', 'bold');
    doc.text('Email Address:', 3, yPos);
    doc.setFont('helvetica', 'normal');
    const emailText = doc.splitTextToSize(personemail, 80);
    doc.text(emailText, 23, yPos);
    yPos += emailText.length * 3;

    // Buyer Details
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    const maxTextWidth = 70;
    const wrappedAddress = doc.splitTextToSize(`${bname}`, maxTextWidth);
    doc.text(wrappedAddress, 125, 18);

    doc.rect(startX + colWidthBig, startY, colWidthNormal, rowHeight);
    doc.rect(startX + colWidthBig1, startY, colWidthNormal1, rowHeight);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text('Buyer:', 115, 18);
    doc.text('Tel No.:', 115, 36);

    // Quotation Details
    doc.text('Quotation Date.:', 189, 18);
    doc.setFont('helvetica', 'normal');
    doc.text(qdate, 218, 18);
    doc.setFont('helvetica', 'bold');
    doc.text('Payment Terms:', 189, 21);
    doc.setFont('helvetica', 'normal');
    doc.text('30% Advance 70% Against OBL', 218, 21);
    doc.setFont('helvetica', 'bold');
    doc.text('Production Lead Time:', 189, 24);
    doc.setFont('helvetica', 'normal');
    doc.text('90 Days', 218, 24);
    doc.setFont('helvetica', 'bold');
    doc.text('Price Terms:', 189, 27);
    doc.setFont('helvetica', 'normal');
    doc.text('FOB', 218, 27);
    doc.setFont('helvetica', 'bold');
    doc.text('Port of Loading:', 189, 30);
    doc.setFont('helvetica', 'normal');
    doc.text('Mundra / Nhava Sheva', 218, 30);

    // ✅ Table rows - Single row per product
    // Table rows with formatted decimals
    const safeNumber = val => {
      const num = parseFloat(val);
      return isNaN(num) ? 0 : num;
    };

    const rows = data.map((item, index) => {
      const originalUnit = item.SizeUnit?.toLowerCase() === 'inch' ? 'inch' : 'cm';

      const quotation = qdata.find(q => q.QuotationProductcode == item.id);
      // const price = safeNumber(quotation ? quotation.Price : 0);
      // const MOQ = safeNumber(quotation ? quotation.MOQ : 0);
      // const totalAmount = safeNumber(price * MOQ);
      let price = quotation ? parseFloat(quotation.Price) : 0;
      const MOQ = quotation ? parseFloat(quotation.MOQ) : 0;

      // 🔥 Convert price from INR → Selected Currency
      if (selectedCurrency !== 'INR') {
        price = price / selectedRate;
      }

      // Optional: round to 2 decimals
      price = Number(price.toFixed(2));

      const totalAmount = Number((price * MOQ).toFixed(2));
      const setStatus = item.attributes.SetStatus || 'Single';

      // Inner & Master counts
      const innerCount = item.attributes.Packaging
        ? item.attributes.Packaging.filter(pack => pack.CartonType === 'inner').reduce(
            (sum, pack) => sum + (parseFloat(pack.Carton_PCS) || 0),
            0
          )
        : 0;

      const masterCount = item.attributes.Packaging
        ? item.attributes.Packaging.filter(pack => pack.CartonType === 'master').reduce(
            (sum, pack) => sum + (parseFloat(pack.Carton_PCS) || 0),
            0
          )
        : 0;

      const masterCarton = item.attributes.Packaging
        ? item.attributes.Packaging.find(pack => pack.CartonType === 'master')
        : null;

      const masterLength = masterCarton
        ? parseFloat(convertDimension(masterCarton.Carton_Length, originalUnit, unit)).toFixed(2)
        : '';
      const masterWidth = masterCarton
        ? parseFloat(convertDimension(masterCarton.Carton_Width, originalUnit, unit)).toFixed(2)
        : '';
      const masterThick = masterCarton
        ? parseFloat(convertDimension(masterCarton.Carton_Thick, originalUnit, unit)``).toFixed(2)
        : '';
      const masterCBM = masterCarton ? parseFloat(masterCarton.Carton_CBM).toFixed(4) : '';
      const masterUnit = masterCarton ? unit : '';

      if (setStatus === 'Set' && item.attributes.SetSizes?.length > 0) {
        const allLengths = item.attributes.SetSizes.map(s =>
          parseFloat(convertDimension(s.Length, originalUnit, unit) || 0).toFixed(2)
        ).join('\n');
        const allWidths = item.attributes.SetSizes.map(s =>
          parseFloat(convertDimension(s.Width, originalUnit, unit) || 0).toFixed(2)
        ).join('\n');
        const allHeights = item.attributes.SetSizes.map(s =>
          parseFloat(convertDimension(s.Height, originalUnit, unit) || 0).toFixed(2)
        ).join('\n');
        const allColorFinish = item.attributes.SetSizes.map(
          s => `${s.ColorName || ''} / ${s.FinishName || ''}`
        ).join('\n');
        const allNetWeights = item.attributes.SetSizes.map(s => s.NetWt || '').join('\n');
        const sizeUnit = unit || '';

        return [
          index + 1,
          item.attributes.ProductId,
          item.attributes.CoverImage?.data?.attributes?.url || '',
          item.attributes.Description,
          allLengths,
          allWidths,
          allHeights,
          sizeUnit,
          allColorFinish,
          item.attributes.ProductionDetail?.map(d => d.MaterialNm).join(', ') || '',
          allNetWeights,
          innerCount,
          masterCount,
          price.toFixed(2), // F.O.B
          item.attributes.SellingPriceCurrency || '', // Currency
          MOQ.toFixed(0), // MOQ
          masterLength,
          masterWidth,
          masterThick,
          masterUnit,
          'Set',
          masterCBM,

          item.attributes.Product_Remark || ''
        ];
      } else {
        return [
          index + 1,
          item.attributes.ProductId,
          item.attributes.CoverImage?.data?.attributes?.url || '',
          item.attributes.Description,
          item.attributes.Length
            ? parseFloat(convertDimension(item.attributes.Length, originalUnit, unit)).toFixed(2)
            : '',
          item.attributes.Width
            ? parseFloat(convertDimension(item.attributes.Width, originalUnit, unit)).toFixed(2)
            : '',
          item.attributes.Height
            ? parseFloat(convertDimension(item.attributes.Height, originalUnit, unit)).toFixed(2)
            : '',
          unit || '',
          `${item.attributes.ColorName || ''} / ${item.attributes.FinishName || ''}`,
          item.attributes.ProductionDetail?.map(d => d.MaterialNm).join(', ') || '',
          item.attributes.NetWeight || '',
          innerCount,
          masterCount,
          price.toFixed(2), // F.O.B
          item.attributes.SellingPriceCurrency || '', // Currency
          MOQ.toFixed(0), // MOQ
          masterLength,
          masterWidth,
          masterThick,
          masterUnit,

          'Pc',
          masterCBM,
          item.attributes.Product_Remark || ''
        ];
      }
    });

    // Generate the table
    doc.autoTable({
      head: [
        [
          { content: 'S.No', rowSpan: 2 },
          {
            content: 'Supp. Item No.',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          { content: 'Photo Ref:', rowSpan: 2 },
          {
            content: 'Item\nDescription',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          {
            content: 'Item Dimension',
            colSpan: 3,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          {
            content: 'Unit',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          {
            content: 'Color/Finish',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          {
            content: 'Material\nUsed',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          {
            content: 'Net Weight (kg)',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          { content: 'Carton', colSpan: 2 },
          {
            content: 'F.O.B\nUnit\nPrice',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          {
            content: 'Currency',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          { content: 'MOQ', rowSpan: 2 },
          {
            content: 'Carton Size',
            colSpan: 3,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          { content: 'Unit', rowSpan: 2 },
          {
            content: 'Unit(Set/Pc)',
            rowSpan: 2,
            styles: { cellPadding: { top: 2, bottom: 2, left: 1, right: 1 } }
          },
          { content: 'CBM/CTN', rowSpan: 2 },
          { content: 'Remarks', rowSpan: 2 }
        ],
        ['Length', 'Width', 'Height', 'Inner', 'Master', 'Length', 'Width', 'Height']
      ],
      body: rows,
      startY: 38,
      theme: 'grid',
      styles: {
        fontSize: 6,
        halign: 'center',
        valign: 'middle',
        lineColor: [0, 0, 0],
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontSize: 6,
        halign: 'center'
      },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 12 },
        2: { cellWidth: 20 }
      },
      didDrawCell: data => {
        if (data.column.index === 2 && data.row.section === 'body') {
          const imageURL = data.row.raw[2];
          if (!imageURL) return;

          const fimageURL = `${ip}${imageURL}`;
          const watermarkURL = `${ip}${waterMarkURL}`;

          const cellWidth = data.cell.width;
          const cellHeight = data.cell.height;
          const imgWidth = 18;
          const imgHeight = 16;
          const xPos = data.cell.x + (cellWidth - imgWidth) / 2;
          const yPos = data.cell.y + (cellHeight - imgHeight) / 2;

          doc.addImage(fimageURL, 'JPEG', xPos, yPos, imgWidth, imgHeight);

          if (waterMark) {
            const watermarkWidth = 25;
            const watermarkHeight = 20;
            const watermarkXPos = xPos + (imgWidth - watermarkWidth) / 2;
            const watermarkYPos = yPos + (imgHeight - watermarkHeight) / 2;
            doc.addImage(
              watermarkURL,
              'PNG',
              watermarkXPos,
              watermarkYPos,
              watermarkWidth,
              watermarkHeight,
              undefined,
              'SLOW'
            );
          }
        }
      },
      rowPageBreak: 'auto',
      bodyStyles: {
        minCellHeight: 18
      },
      margin: { left: 2, right: 2 }
    });

    const finalY = doc.autoTable.previous.finalY || 0;
    doc.setFontSize(10);
    doc.text(`For ${compname}`, 250, finalY + 6);
    doc.text('Authorised Signatory', 250, finalY + 25);

    return doc;
  };

  useEffect(() => {
    fetchDatacurr();
  }, []);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const fetchDatacurr = async () => {
    try {
      const response = await fetch(`${ip}/api/currency-masters`);
      const json = await response.json();

      const currency = json.data.map(item => ({
        label: item.attributes.currencyname, // Setting label
        value: item.attributes.currencyname, // Setting value
        exchangerate: item.attributes.exchangerate
      }));
      setCurrencyOptions(currency);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleDownloadPDF3 = async (unit = 'cm', currency = 'USD') => {
    try {
      const doc = generatePDF3(cata, qdata, unit);
      const pdfBlob = doc.output('blob');
      const base64String = await blobToBase64(pdfBlob);

      // Save the downloaded file for email attachment
      setDownloadedFile({
        filename: `Quotation_${qutname || 'Document'}.pdf`,
        blob: pdfBlob,
        base64: base64String
      });
      // Save the PDF
      doc.save(`Quotation_${qutname || 'Document'}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const handleChangeLimit = dataKey => {
    setPage(1);
  };
  const handleChangeLimit1 = dataKey => {
    setPage1(1);
  };
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [finShow, setFinShow] = useState(false);

  const [sizeshow, setSizeShow] = useState(false);
  // const [compdata, setCompData] = useState<any>([]);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      setFinShow(json.data[0].attributes.setFinish);

      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
      setCompData(json.data[0]);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [openMenu, setOpenMenu] = useState(false);

  const [format, setFormat] = useState(false);
  const formatOpen = () => setFormat(true);
  const formatClose = () => setFormat(false);

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;

  const [vardata, setVarData] = useState([]);
  const fetchDataVData = async id => {
    try {
      const response = await fetch(
        `${globalIP}/api/variant-products?filters[Variant_Id][$eq]=${id}&populate=*`
      );
      const json = await response.json();
      setVarData(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [varOpen, setVarOpen] = useState(false);
  const openVardata = id => {
    setVarOpen(true);
    fetchDataVData(id);
  };

  const columns = [
    {
      key: 'ProductId',
      label: 'Assign',
      width: 100,
      fixed: true,
      headerCell: (
        <Table.HeaderCell>
          <b>Assign</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => (
            <Checkbox
              checked={editedProducts
                ?.map(item => item.QuotationProductcode)
                .includes(String(rowData.id))}
              onChange={() => handleProductToggle(rowData)}
            />
          )}
        </Cell>
      )
    },
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img
                  src={imageSrc}
                  alt="Product Image"
                  style={{ width: 400, height: 400, objectFit: 'contain' }}
                />
              </Tooltip>
            );

            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`
                )}
              >
                <img
                  src={`${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-12px', objectFit: 'contain' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductId}</Cell>
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.Description}</Cell>
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductName}</Cell>
    },
    {
      key: sizeshow ? 'SizeRange' : 'Dimension',
      label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            sizeshow
              ? rowData.attributes.SizeRange
              : `${rowData.attributes.Length} x ${rowData.attributes.Width} x ${rowData.attributes.Height} ${rowData.attributes.SizeUnit}`
          }
        </Cell>
      )
    },
    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 120,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.FinishName}</Cell>
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 120,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ColorName}</Cell>
    },
    {
      key: 'Action',
      label: `Action`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            rowData.attributes.Variant === true ? (
              <>
                <Button
                  appearance="ghost"
                  color="cyan"
                  onClick={() => openVardata(rowData.attributes.ProductCode)}
                >
                  Variant
                </Button>
              </>
            ) : (
              <>
                <p>-</p>
              </>
            )
          }
        </Cell>
      )
    }
  ];
  const [columnKeys, setColumnKeys] = useState(columns.map(column => column.key));
  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);

  const [searchQuery1, setSearchQuery1] = useState('');
  const handleSearch1 = value => {
    setSearchQuery1(value);
  };

  const [editingCollection, setEditingCollection] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [editedProducts, setEditedProducts] = useState([]);
  const [isModalOpenp, setIsModalOpenp] = useState(false);
  const [loadingadd, setLoadingAdd] = useState(false);
  const navigate = useNavigate();
  const handleEdit = collection => {
    console.log('collection');
    console.log(collection);
    const productstring = collection.attributes.QuotationProduct.map(
      product => product.QuotationProductcode
    ).join(','); // Join them with '0' as the separator
    navigate(
      `/${ugr}/editDetailsQ?selectedItems=${productstring}&updateQuotation=${collection.attributes.QuotationCode}`
    );

    // console.log('productstring');
    // console.log(productstring);
    // setEditingCollection(collection);
    // setIsModalOpenp(true);
    // setEditedProducts(collection.attributes.QuotationProduct);
  };
  const handleSave = async collection => {
    try {
      setLoadingAdd(true);
      const response = await fetch(`${globalIP}/api/quotations/${collection.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { QuotationProduct: editedProducts } })
      });

      if (response.ok) {
        fetchData();
        setLoadingAdd(false);
        setEditingCollection(null);
        setEditedProducts([]);
      } else {
        const errorResponse = await response.json();
        console.error('Error saving collection:', errorResponse);
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setEditingCollection(null);
    setEditedProducts([]);
    setIsModalOpen(false);
  };
  const [isAnyCheckboxSelected, setIsAnyCheckboxSelected] = useState(true);
  const handleProductToggle = productId => {
    setEditedProducts(prevProducts => {
      const isProductIncluded = editedProducts.some(
        item => item.QuotationProductcode == String(productId.id)
      );

      let updatedProducts;
      if (isProductIncluded) {
        updatedProducts = prevProducts.filter(
          item => item.QuotationProductcode != String(productId.id)
        );
      } else {
        updatedProducts = [
          ...prevProducts,
          {
            QuotationCode: editingCollection.attributes.QuotationCode,
            QuotationProductcode: String(productId.id),
            Price: productId.attributes.SellingPrice,
            MOQ: productId.attributes.MOQ
          }
        ];
      }

      setIsAnyCheckboxSelected(updatedProducts.length > 0);
      return updatedProducts;
    });
  };

  const handleCheckboxChange = (rowId, checked) => {
    setEditedProducts(prevProducts => {
      if (checked) {
        const product = vardata.find(item => item.id == rowId);
        if (product) {
          return [
            ...prevProducts,
            {
              QuotationProductcode: String(product.id),
              QuotationCode: editingCollection.attributes.QuotationCode,
              Price: product.attributes.SellingPrice,
              MOQ: product.attributes.MOQ
            }
          ];
        } else {
          console.warn('Product not found in vardata for ID:', rowId);
        }
      } else {
        console.log('Removing product with ID:', rowId);
        return prevProducts.filter(product => product.CatalogProduct !== String(rowId));
      }
      return prevProducts;
    });
  };

  const handleCheckAllT = checked => {
    if (!checked) {
      // Add products to editedProducts that are not already present
      const newProducts = vardata
        .map(product => ({
          QuotationProductcode: String(product.id),
          QuotationCode: editingCollection.attributes.QuotationCode,
          Price: product.attributes.SellingPrice,
          MOQ: product.attributes.MOQ
        }))
        .filter(
          newProduct =>
            !editedProducts.some(
              existingProduct =>
                existingProduct.QuotationProductcode === String(newProduct.QuotationProductcode)
            )
        ); // Ensure it's not already in the existing list
      setEditedProducts(prevState => [...prevState, ...newProducts]);
    }
    if (checked) {
      setEditedProducts(prevState =>
        prevState.filter(
          product =>
            !vardata.some(row => {
              console.log('`${row.id} ${product.QuotationProductcode}`');
              console.log(`${row.id} ${product.QuotationProductcode}`);

              return row.id === parseInt(product.QuotationProductcode);
            })
        )
      );
    }
  };
  const handleEscKey = event => {
    if (event.key === 'Escape') {
      setEditingCollection(null);
      setEditedProducts([]);
      setIsModalOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, []);
  const [selectedFormat, setSelectedFormat] = useState(null);
  // const handleDownload = async () => {
  //   if (selectedFormat === '1') {
  //     await downloadExcelData(csvData);
  //   } else if (selectedFormat === '2') {
  //     await downloadExcelData1(csvData);
  //   } else if (selectedFormat === '3') {
  //     await handleDownloadPDF3();
  //   } else {
  //     toaster.push(
  //       <Message showIcon type="error">
  //         Please Select Format
  //       </Message>,
  //       { placement: 'topCenter' }
  //     );
  //   }
  // };

  const [selectedUnit, setSelectedUnit] = useState('cm');

  const [selectedCurrency, setSelectedCurrency] = useState('USD');
  // Get selected currency object from dynamic API data
  const selectedCurrencyObj = currencyOptions.find(c => c.value === selectedCurrency);

  // Default to INR if nothing selected
  const selectedRate = selectedCurrencyObj ? Number(selectedCurrencyObj.exchangerate) : 1;
  const handleDownload = async () => {
    if (selectedFormat === '1') {
      await downloadExcelData(csvData, selectedUnit, selectedCurrency);
    } else if (selectedFormat === '2') {
      await downloadExcelData1(csvData, selectedUnit, selectedCurrency);
    } else if (selectedFormat === '3') {
      await handleDownloadPDF3(selectedUnit, selectedCurrency);
    } else {
      toaster.push(
        <Message showIcon type="error">
          Please Select Format
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    // After download, show success message with email suggestion
    toaster.push(
      <Message showIcon type="success">
        Document downloaded successfully! You can now email it to the buyer.
      </Message>,
      { placement: 'topCenter' }
    );

    formatClose();
  };
  const options = [
    { label: 'Excel 1', value: '1' },
    { label: 'Excel 2', value: '2' },
    { label: 'PDF', value: '3' }
  ];
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 320; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);

  const [showDimm, setShowDimm] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleOpenDimm = row => {
    setSelectedRow(row);
    console.log('ROW :', row);
    setShowDimm(true);
  };
  const handleCloseDimm = () => setShowDimm(false);
  const unitOptions = [
    { label: 'Centimeter (cm)', value: 'cm' },
    { label: 'Inches (in)', value: 'inch' }
  ];

  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack
          className="table-toolbar quotation-head"
          justifyContent="space-between"
          style={{ position: 'relative', zIndex: 1 }}
        >
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="row" alignItems="flex-start" spacing={93} className="mng-ord-q">
                <h3 className="title">Manage Quotation</h3>
                <div onClick={() => setOpenMenu(!openMenu)}>
                  <MenuIcon className="burgerMenu1" />
                  {/* <CloseIcon className='burgerMenu1'/> */}
                </div>
              </Stack>{' '}
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Manage Quotation</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5} className={openMenu ? 'mange-item' : 'mange-search'}>
              <Stack direction="column" alignItems="flex-start">
                <label style={{ visibility: 'hidden' }}>Type</label>
                <SelectPicker
                  value={selectedOption}
                  onChange={handleOptionChange}
                  data={[
                    { label: 'Quotations', value: 'Option 1' },
                    { label: 'Fetch Catalogues', value: 'Option 2' }
                  ]}
                  size="md"
                  appearance="default"
                  placeholder="Status"
                  style={{ width: 150 }}
                  cleanable={false}
                />
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                <label>Buyer Company</label>
                <SelectPicker
                  data={buyeerCompNamedata}
                  onChange={value => {
                    setSelectedBuyerCompName(value);
                    setPage(1);
                    setFilterApplied(true);
                    const buyerFilteredCount = cataloguedata.filter(item => {
                      const buyerMatch = !value || item.attributes.BuyerCompany === value;
                      return buyerMatch;
                    }).length;

                    setFoundProductCount(buyerFilteredCount);
                  }}
                  onClean={() => {
                    setSelectedBuyerCompName('');
                    setFilterApplied(false);
                  }}
                  size="md"
                  appearance="default"
                  placeholder={'Buyer Company'}
                  style={{ width: 200 }}
                />
              </Stack>
              {selectedOption != 'Option 2' && (
                <Stack direction="column" alignItems="flex-start">
                  <label>{`${label[0]?.attributes.BuyerName}`}</label>
                  <SelectPicker
                    data={buyeerdata}
                    onChange={value => {
                      setSelectedBuyerName(value);
                      setPage(1);
                      setFilterApplied(true);
                      const buyerFilteredCount = cataloguedata.filter(item => {
                        const buyerMatch = !value || item.attributes.BuyerName === value;
                        return buyerMatch;
                      }).length;

                      setFoundProductCount(buyerFilteredCount);
                    }}
                    onClean={() => {
                      setSelectedBuyerName('');
                      setFilterApplied(false);
                    }}
                    size="md"
                    appearance="default"
                    placeholder={`${label[0]?.attributes.BuyerName}`}
                    style={{ width: 200 }}
                  />
                </Stack>
              )}
              <Stack direction="column" alignItems="flex-start">
                <label style={{ visibility: 'hidden' }}>Status</label>
                <SelectPicker
                  value={selectedOption1}
                  onChange={handleOptionChange1}
                  data={[
                    { label: 'Active', value: 'Active' },
                    { label: 'All Quotations', value: 'All' },
                    { label: 'Inactive', value: 'Inactive' },
                    { label: 'Draft', value: 'Draft' }
                  ]}
                  size="md"
                  appearance="default"
                  placeholder="Status"
                  style={{ width: 150 }}
                  cleanable={false}
                />
              </Stack>
            </Stack>
          </Stack>

          <Stack
            direction="row"
            alignItems="flex-end"
            spacing={16}
            className="mange-search quotation-search1"
          >
            <Stack direction="row" spacing={5} className="quotation-srch">
              <InputGroup inside>
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={value => {
                    setSearchQuery(value);
                  }}
                  className="pdt-srch"
                />
                <InputGroup.Addon>
                  <SearchIcon style={{ cursor: 'pointer' }} />
                </InputGroup.Addon>
              </InputGroup>
            </Stack>
            <Link to={`/${ugr}/selectionQ`}>
              <Button appearance="primary" color="cyan">
                Create Quotation
              </Button>
            </Link>
          </Stack>
        </Stack>

        <Divider className="divide" />
        <div className="row">
          <Panel>
            {selectedOption == 'Option 1' && (
              <>
                {/* {setSearchQryBtn && (
                  <b style={{ marginLeft: '6px' }}>Total Quotations: {meta123.pagination.total}</b>
                )} */}
                {/* {searchQuery && (
                  <b style={{ marginLeft: '6px' }}>Found Quotations: {foundProductCount}</b>
                )} */}
                {/* {selectedBuyerName && !searchQuery && (
                  <b style={{ marginLeft: '6px' }}>Found Quotations: {foundProductCount}</b>
                )} */}
                {/* {meta123 && (
                  <b style={{ marginLeft: '6px' }}>Total Quotations: {meta123.pagination.total}</b>
                )} */}
                <Table
                  height={tableHeight}
                  // data={cataloguedata.filter(item => {
                  //   const productName = item.attributes.QuotationName.toLowerCase();
                  //   const aliasCode = item.attributes.Q_BuyerCompany.toLowerCase();
                  //   const ContNo = item.attributes.QuotationCode.toLowerCase();
                  //   const buyer = item.attributes.Q_BuyerCompany;
                  //   if (filterApplied) {
                  //     if (!buyer) {
                  //       return false;
                  //     }
                  //   }
                  //   const addedDate = new Date(item.attributes.createdAt);
                  //   const today = new Date();
                  //   const daysAgo = (date, days) => {
                  //     const result = new Date(date);
                  //     result.setDate(result.getDate() - days);
                  //     return result;
                  //   };
                  //   let dateMatch = true;
                  //   if (selectedDateRange === 'Today') {
                  //     dateMatch = addedDate.toDateString() === today.toDateString();
                  //   } else if (selectedDateRange === 'Yesterday') {
                  //     dateMatch = addedDate.toDateString() === daysAgo(today, 1).toDateString();
                  //   } else if (selectedDateRange === 'This week') {
                  //     dateMatch = addedDate >= daysAgo(today, 7);
                  //   } else if (selectedDateRange === 'Last week') {
                  //     dateMatch = addedDate >= daysAgo(today, 14) && addedDate < daysAgo(today, 7);
                  //   } else if (selectedDateRange === 'This month') {
                  //     const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                  //     dateMatch = addedDate >= startOfMonth;
                  //   } else if (selectedDateRange === 'Last month') {
                  //     const startOfLastMonth = new Date(
                  //       today.getFullYear(),
                  //       today.getMonth() - 1,
                  //       1
                  //     );
                  //     const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                  //     dateMatch = addedDate >= startOfLastMonth && addedDate <= endOfLastMonth;
                  //   } else if (selectedDateRange === 'Last 3 month') {
                  //     const threeMonthsAgo = new Date();
                  //     threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
                  //     dateMatch = addedDate >= threeMonthsAgo;
                  //   } else if (selectedDateRange === 'Last 6 month') {
                  //     const sixMonthsAgo = new Date();
                  //     sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
                  //     dateMatch = addedDate >= sixMonthsAgo;
                  //   }
                  //   const buyerNameMatch = !selectedBuyerName || selectedBuyerName.includes(buyer);
                  //   return (
                  //     (productName.includes(searchQuery.toLowerCase()) ||
                  //       aliasCode.includes(searchQuery.toLowerCase()) ||
                  //       ContNo.includes(searchQuery.toLowerCase())) &&
                  //     dateMatch &&
                  //     buyerNameMatch
                  //   );
                  // })}
                  data={cataloguedata}
                  bordered
                  cellBordered
                  loading={isLoading}
                  wordWrap="break-word"
                >
                  <Table.Column width={80} align="center" fixed>
                    <HeaderCell>
                      <b>Sr. No.</b>
                    </HeaderCell>
                    <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                  </Table.Column>

                  <Column width={300} align="center">
                    <HeaderCell>
                      <b>Quotation Name</b>
                    </HeaderCell>
                    <Cell>
                      {rowData => (
                        <>
                          <div style={{ display: 'grid' }}>
                            {rowData.attributes.QuotationName}

                            {rowData.id === editingCollection?.id ? (
                              <div>
                                <Modal
                                  size="full"
                                  open={isModalOpenp}
                                  onClose={() => setIsModalOpenp(false)}
                                  backdrop="static"
                                  className="modal"
                                >
                                  <FlexboxGrid justify="space-between">
                                    <FlexboxGrid.Item colspan={6}>
                                      <b>Add/Remove Products</b>
                                    </FlexboxGrid.Item>
                                    <FlexboxGrid.Item colspan={6}>
                                      <InputGroup inside>
                                        <Input
                                          placeholder="Search"
                                          type="text"
                                          value={searchQuery1}
                                          onChange={value => handleSearch1(value)}
                                        />
                                        <InputGroup.Addon>
                                          <SearchIcon />
                                        </InputGroup.Addon>
                                      </InputGroup>
                                    </FlexboxGrid.Item>
                                  </FlexboxGrid>
                                  <Modal.Body>
                                    {isLoading1 ? (
                                      <Loader size="sm" speed="fast" center content="Loading..." />
                                    ) : (
                                      <>
                                        <Table
                                          data={productData.filter(item => {
                                            const ProductName = item.attributes.ProductName
                                              ? item.attributes.ProductName.toLowerCase()
                                              : '';
                                            const AliasCode = item.attributes.ProductId
                                              ? item.attributes.ProductId.toLowerCase()
                                              : '';
                                            const ColorName = item.attributes.ColorName
                                              ? item.attributes.ColorName.toLowerCase()
                                              : '';
                                            const FinishName = item.attributes.FinishName
                                              ? item.attributes.FinishName.toLowerCase()
                                              : '';

                                            return (
                                              ProductName.includes(searchQuery1.toLowerCase()) ||
                                              AliasCode.includes(searchQuery1.toLowerCase()) ||
                                              ColorName.includes(searchQuery1.toLowerCase()) ||
                                              FinishName.includes(searchQuery1.toLowerCase())
                                            );
                                          })}
                                          height={500}
                                          wordWrap
                                          rowKey="id"
                                          cellBordered
                                          bordered
                                        >
                                          {columns.map(column => {
                                            if (columnKeys.includes(column.key)) {
                                              const { key, label, headerCell, cell, ...rest } =
                                                column;
                                              return (
                                                <Table.Column {...rest} key={key} align="center">
                                                  {headerCell || (
                                                    <CustomHeaderCell>{label}</CustomHeaderCell>
                                                  )}
                                                  {cell || <CustomCell dataKey={key} />}
                                                </Table.Column>
                                              );
                                            }
                                            return null;
                                          })}
                                        </Table>
                                        <div style={{ padding: 20 }}>
                                          <Pagination
                                            prev
                                            next
                                            first
                                            last
                                            ellipsis
                                            boundaryLinks
                                            maxButtons={5}
                                            limit={25}
                                            size="xs"
                                            layout={['total', '-', 'pager', 'skip']}
                                            total={metaedit?.pagination?.total || 0}
                                            activePage={pageedit}
                                            onChangePage={setPageEdit}
                                            onChangeLimit={handleChangeLimitEdit}
                                          />
                                        </div>
                                      </>
                                    )}
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button appearance="subtle" active onClick={handleCancel}>
                                      Cancel
                                    </Button>
                                    <Button
                                      onClick={() => handleSave(editingCollection)}
                                      appearance="primary"
                                      color="cyan"
                                      disabled={!isAnyCheckboxSelected}
                                      loading={loadingadd}
                                    >
                                      Save
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                              </div>
                            ) : (
                              <span style={{ fontSize: '12px', color: 'gray' }}>
                                {rowData.itemCount} Products
                              </span>
                            )}
                          </div>
                        </>
                      )}
                    </Cell>
                  </Column>
                  <Column width={160} align="center">
                    <HeaderCell>
                      <b>Buyer Company</b>
                    </HeaderCell>
                    <Cell dataKey={'attributes.Q_BuyerCompany'} />
                  </Column>
                  <Column width={150} align="center">
                    <HeaderCell>
                      <b>{`${label[0]?.attributes.BuyerName}`}</b>
                    </HeaderCell>
                    <Cell dataKey={'attributes.Q_BuyerName'} />
                  </Column>
                  <Column width={100} align="center">
                    <HeaderCell>
                      <b>Status</b>
                    </HeaderCell>
                    <Cell dataKey={'attributes.Q_Status'}>
                      {rowData => (
                        <Button
                          className={getStatusButtonClass(rowData.attributes.Q_Status)}
                          style={{ width: 'auto' }}
                          size="sm"
                        >
                          {rowData.attributes.Q_Status}
                        </Button>
                      )}
                    </Cell>
                  </Column>
                  <Column width={80} align="center">
                    <HeaderCell>
                      <b>View</b>
                    </HeaderCell>
                    <Cell>
                      {rowData => (
                        <>
                          <Whisper followCursor speaker={<Tooltip>View Products</Tooltip>}>
                            <IconButton
                              size="xs"
                              icon={<VisibleIcon />}
                              active
                              onClick={() => handleMoreIconClick(rowData)}
                              style={{ marginRight: '10px' }}
                            />
                          </Whisper>
                        </>
                      )}
                    </Cell>
                  </Column>
                  <Column width={400}>
                    <HeaderCell>
                      <b>Action</b>
                    </HeaderCell>
                    <Table.Cell>
                      {rowData => (
                        <div className="d-flex align-items-center flex-wrap">
                          <Whisper followCursor speaker={<Tooltip>Download</Tooltip>}>
                            <IconButton
                              size="xs"
                              icon={<SortDownIcon />}
                              active
                              style={{ marginRight: '10px' }}
                              onClick={() => {
                                fetchDatabyid(rowData.id);
                                formatOpen();
                                // Store row data for email context
                                setCurrentRowData(rowData);
                              }}
                            />
                          </Whisper>
                          {!editingCollection || rowData.id !== editingCollection.id ? (
                            <Whisper followCursor speaker={<Tooltip>Add/Remove Products</Tooltip>}>
                              <IconButton
                                style={{ marginRight: '10px' }}
                                icon={<EditIcon />}
                                size="xs"
                                active
                                onClick={() => handleEdit(rowData)}
                              />
                            </Whisper>
                          ) : (
                            <>
                              <IconButton
                                style={{ marginRight: '10px' }}
                                size="xs"
                                icon={<CheckIcon />}
                                active
                                onClick={() => handleSave(rowData)}
                                disabled={!isAnyCheckboxSelected}
                              />

                              <IconButton
                                style={{ marginRight: '10px' }}
                                size="xs"
                                icon={<CloseIcon />}
                                active
                                onClick={() => handleCancel()}
                              />
                            </>
                          )}

                          <Whisper followCursor speaker={<Tooltip>Delete Quotation</Tooltip>}>
                            <IconButton
                              size="xs"
                              icon={<TrashIcon />}
                              active
                              style={{ marginRight: '10px' }}
                              onClick={() => openDeleteModal(rowData.id)}
                            />
                          </Whisper>
                          <Whisper followCursor speaker={<Tooltip>Active/Inactive</Tooltip>}>
                            <IconButton
                              size="xs"
                              icon={<MoreIcon />}
                              active
                              style={{ marginRight: '10px' }}
                              onClick={() => toggleStatusPicker(rowData.id)}
                            />
                          </Whisper>
                          {isStatusPickerVisible[rowData.id] && ( // Render SelectPicker if isVisible is true
                            <SelectPicker
                              data={statusOptions}
                              value={rowData.attributes.Q_Status}
                              onChange={newStatus => handleStatusChange(rowData.id, newStatus)}
                              style={{ width: 120, marginTop: '-8px', marginRight: '10px' }}
                              cleanable={false}
                              placement="auto"
                            />
                          )}
                          {rowData.attributes.Q_Status === 'Active' && ( // Check if status is 'Active'
                            <Whisper followCursor speaker={<Tooltip>Email</Tooltip>}>
                              <IconButton
                                size="xs"
                                icon={<EmailIcon />}
                                active
                                style={{ marginRight: '10px', color: 'red' }}
                                onClick={() =>
                                  handleOpen(
                                    'sm',
                                    rowData.attributes.Q_BuyerEmail,
                                    rowData.attributes.Q_BuyerCompany,
                                    rowData
                                  )
                                }
                              />
                            </Whisper>
                          )}
                          <WhatsApp {...{ rowData, imger }} />
                        </div>
                      )}
                    </Table.Cell>
                  </Column>
                </Table>

                <div style={{ padding: 20 }}>
                  <Pagination
                    prev
                    next
                    first
                    last
                    ellipsis
                    boundaryLinks
                    maxButtons={5}
                    size="xs"
                    layout={['total', '-', 'pager', 'skip']}
                    total={meta123?.pagination?.total || 0}
                    activePage={page}
                    onChangePage={setPage}
                    onChangeLimit={handleChangeLimit}
                  />
                </div>
              </>
            )}
            <Modal open={showModal} onClose={closeDeleteModal} backdrop="static" size="xs">
              <Modal.Header>
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>Are you sure you want to delete this quotation?</Modal.Body>
              <Modal.Footer>
                <Button onClick={closeDeleteModal} appearance="subtle" active>
                  No
                </Button>
                <Button onClick={handleConfirmDelete} appearance="primary" color="cyan">
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
            <ViewModal
              header="Quotation"
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              cataname={cataname}
              label={label}
              fetchProducts1={fetchProducts1}
              tableHeight={tableHeight}
              currentPage={currentPage}
              handleOpenDimm={handleOpenDimm}
              sizeshow={sizeshow}
              handleChangeLimitforviw={handleChangeLimitforviw}
              setPageView={setPageView}
              pageview={pageview}
              metaview={metaview}
            />
            {selectedOption === 'Option 2' && (
              <>
                <b style={{ marginLeft: '6px' }}>
                  Total Fetch Catalogues: {meta1231?.pagination?.total}
                </b>
                {/* {selectedBuyerName && (
                      <b style={{ marginLeft: '6px' }}>Found Quotations: {foundProductCount}</b>
                    )} */}
                <Table
                  height={tableHeight}
                  data={cataloguedata1}
                  bordered
                  cellBordered
                  loading={isLoading}
                >
                  <Table.Column width={80} align="center" fixed>
                    <HeaderCell>
                      <b>Sr. No.</b>
                    </HeaderCell>
                    <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                  </Table.Column>

                  <Column width={250} align="center">
                    <HeaderCell>
                      <b>Catalogue Name</b>
                    </HeaderCell>
                    <Cell dataKey={'attributes.catalogueName'} />
                  </Column>
                  <Column width={100} align="center">
                    <HeaderCell>
                      <b>Products</b>
                    </HeaderCell>
                    <Cell dataKey="itemCount" />
                  </Column>

                  <Column width={250} align="center">
                    <HeaderCell>
                      <b>Buyer Company</b>
                    </HeaderCell>
                    <Cell dataKey={'attributes.BuyerCompany'} />
                  </Column>
                  <Column width={150} align="center">
                    <HeaderCell>
                      <b>Create/Updated by</b>
                    </HeaderCell>
                    <Cell dataKey={'attributes.createdAt'}>
                      {rowData => formatDate(rowData.attributes.createdAt)}
                    </Cell>
                  </Column>

                  <Column width={200} align="center" flexGrow={1}>
                    <HeaderCell>
                      <b>Controls</b>
                    </HeaderCell>
                    <Cell style={{ padding: '6px' }}>
                      {rowData => (
                        <>
                          <Whisper followCursor speaker={<Tooltip>Create Quotation</Tooltip>}>
                            <IconButton
                              size="xs"
                              icon={<TagAuthorizeIcon />}
                              active
                              onClick={() =>
                                handleCreateQuotation(rowData.attributes.CatalogueCode)
                              }
                              style={{ marginRight: '10px' }}
                            />
                          </Whisper>
                        </>
                      )}
                    </Cell>
                  </Column>

                  {/* <Column width={50}>
                  <HeaderCell>
                  </HeaderCell>
                  <ActionCell dataKey="id" rowData={undefined} />
                </Column> */}
                </Table>
                <div style={{ padding: 20 }}>
                  <Pagination
                    prev
                    next
                    first
                    last
                    ellipsis
                    boundaryLinks
                    maxButtons={5}
                    size="xs"
                    layout={['total', '-', 'pager', 'skip']}
                    total={meta1231?.pagination?.total || 100}
                    // total={100}
                    activePage={page1}
                    onChangePage={setPage1}
                    onChangeLimit={handleChangeLimit1}
                  />
                </div>
              </>
            )}
          </Panel>
          <Email
            size={size}
            open={open}
            handleClose={handleClose}
            to={to}
            setTo={setTo}
            subject={subject}
            setSubject={setSubject}
            Textarea={Textarea}
            message={message}
            setMessage={setMessage}
            loading={loading}
            sendemail={sendemail}
            handleAttachmentChange={handleAttachmentChange}
            attachment={attachment}
            onRemoveAttachment={handleRemoveAttachment}
          />
        </div>
        <Modal open={format} onClose={formatClose} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Print Options</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack direction="row" alignItems="flex-start" spacing={5}>
              <div className="d-flex flex-column">
                <p>Format</p>
                <SelectPicker
                  data={options}
                  value={selectedFormat}
                  onChange={setSelectedFormat}
                  placeholder="Select an option"
                  style={{ width: 150, marginBottom: '10px' }}
                  searchable={false}
                />
              </div>

              <div className="d-flex flex-column">
                <p>
                  Unit <span className="text-danger">*</span>
                </p>
                <SelectPicker
                  data={unitOptions}
                  value={selectedUnit}
                  onChange={setSelectedUnit}
                  placeholder="Select Unit"
                  style={{ width: 200, marginBottom: '10px' }}
                  searchable={false}
                />
              </div>

              <div className="d-flex flex-column">
                <p>Currency</p>
                <SelectPicker
                  data={currencyOptions}
                  value={selectedCurrency}
                  onChange={setSelectedCurrency}
                  placeholder="Select Currency"
                  style={{ width: 150, marginBottom: '10px' }}
                  searchable={false}
                />
              </div>
            </Stack>

            {selectedFormat === '2' && (
              <Checkbox
                checked={states}
                onChange={(value, checked) => setStates(checked)}
                style={{ marginTop: '10px' }}
              >
                Include Extra Fields
              </Checkbox>
            )}

            {waterMarkAccess && (
              <Checkbox
                checked={waterMark}
                onChange={(value, checked) => setWaterMark(checked)}
                style={{ marginTop: '10px' }}
              >
                Include Water-Mark
              </Checkbox>
            )}
            <Modal.Footer>
              <Whisper speaker={<Tooltip>Download</Tooltip>}>
                <IconButton
                  icon={<FileDownloadIcon />}
                  appearance="primary"
                  color="cyan"
                  style={{ marginTop: '-10px' }}
                  onClick={handleDownload}
                  disabled={!selectedUnit}
                />
              </Whisper>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
        {selectedRow && (
          <ShowDimensionModal {...{ showDimm, handleCloseDimm, selectedRow, finShow, label }} />
        )}
        <Modal open={varOpen} onClose={() => setVarOpen(false)} size="lg" backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Variants</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table height={250} data={vardata} bordered cellBordered>
              <Column width={50} align="center">
                <HeaderCell style={{ padding: 0 }}>
                  <div style={{ lineHeight: '40px' }}>
                    <Checkbox
                      inline
                      checked={vardata.every(item =>
                        editedProducts.some(product => product.QuotationProductcode == item.id)
                      )}
                      indeterminate={
                        vardata.some(item =>
                          editedProducts.some(product => product.QuotationProductcode == item.id)
                        ) &&
                        !vardata.every(item =>
                          editedProducts.some(product => product.QuotationProductcode == item.id)
                        )
                      }
                      onChange={checked =>
                        handleCheckAllT(
                          vardata.every(item =>
                            editedProducts.some(product => product.QuotationProductcode == item.id)
                          )
                        )
                      }
                    />
                  </div>
                </HeaderCell>
                <Cell>
                  {rowData => {
                    const isChecked = editedProducts
                      .map(item => item.QuotationProductcode)
                      .includes(String(rowData.id));
                    return (
                      <Checkbox
                        checked={isChecked}
                        onChange={(rowId, checked) => handleCheckboxChange(rowData.id, checked)}
                      />
                    );
                  }}
                </Cell>
              </Column>
              <Column width={100} align="center">
                <HeaderCell>
                  <b>Image</b>
                </HeaderCell>
                <Table.Cell>
                  {rowData => {
                    // Define a function to show the enlarged image on hover
                    const renderTooltip = imageSrc => (
                      <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                        <img
                          src={imageSrc}
                          alt="Product Image"
                          style={{ width: 400, height: 'auto' }}
                        />
                      </Tooltip>
                    );
                    return (
                      <Whisper
                        trigger="hover"
                        placement="right"
                        speaker={renderTooltip(
                          `${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`
                        )}
                      >
                        <img
                          src={`${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`}
                          alt="Product Image"
                          style={{ width: 50, height: 50, marginTop: '-16px' }}
                        />
                      </Whisper>
                    );
                  }}
                </Table.Cell>
              </Column>
              <Column width={100} align="center">
                <HeaderCell>
                  <b>Alias Code</b>
                </HeaderCell>
                <Cell dataKey={'attributes.ProductId'} />
              </Column>
              <Column flexGrow={1} align="center" fullText>
                <HeaderCell>
                  <b>Description</b>
                </HeaderCell>
                <Cell dataKey={'attributes.Description'} />
              </Column>
              <Column width={200} align="center">
                <HeaderCell>
                  <b>Product Name</b>
                </HeaderCell>
                <Cell dataKey={'attributes.ProductName'} />
              </Column>
              <Column width={100} align="center">
                <HeaderCell>Finish</HeaderCell>
                <Cell dataKey={'attributes.FinishName'} />
              </Column>
              <Column width={80} align="center">
                <HeaderCell>Color</HeaderCell>
                <Cell dataKey={'attributes.ColorName'} />
              </Column>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setVarOpen(false)} appearance="primary" color="cyan">
              Confirm Selection
            </Button>
          </Modal.Footer>
        </Modal>

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};
export default ManageOrdQ;
